import lang from '../service/lang';
import app from '../service/app';
import { notify } from '../util/notification';
import Champion from '../data/model/Champion';
import { ROLE } from '../data/model/Role';
import { TYPE } from '../data/model/Type';
import { EFFECT } from '../data/model/Effect';
import { WILLPOWER_SAFE_CHAMPIONS } from '../data/champions';
import { synergiesFromChampions } from '../data/synergies';
import roster from './roster';
import router from './router';
import { fromStorage, toStorage } from '../util/storage';
import { requestRedraw } from '../util/animation';
/* eslint-disable import/no-unresolved */
import Worker from 'webworker?filename=scripts/worker-[hash:6].js!./teams/worker';
/* eslint-enable import/no-unresolved */

const PRESETS = {
    'offensive': {
        [ EFFECT.ATTACK ]: 0.6,
        [ EFFECT.IDOL ]: 0.6,
        [ EFFECT.INSEPARABLE ]: 0.6,
        [ EFFECT.MUTANT_AGENDA ]: 0.6,
        [ EFFECT.COSMIC_SUPREMACY ]: 0.4,
        [ EFFECT.CRITICAL_RATE ]: 0.4,
        [ EFFECT.CRITICAL_DAMAGE ]: 0.4,
        [ EFFECT.BLEED ]: 0.5,
        [ EFFECT.COMBO ]: 0.6,
        [ EFFECT.STUN_SPECIAL ]: 0.5,
        [ EFFECT.POWER_GAIN ]: 0.2,
        [ EFFECT.POWER_STEAL ]: 0.2,
        [ EFFECT.ITS_COMPLICATED ]: 0.2,
        [ EFFECT.PERFECT_BLOCK ]: 0.1,
        [ EFFECT.ARMOR ]: 0.1,
        [ EFFECT.HEALTH ]: 0.1,
        [ EFFECT.HEALTH_STEAL ]: 0.2,
        [ EFFECT.HEROES_FOR_HIRE ]: 0.2,
        [ EFFECT.THUNDERBOLTS ]: 0.2,
        [ EFFECT.MASTERMINDS ]: 0.6,
        [ EFFECT.SHIELD_AGENTS ]: 0.6,
        [ EFFECT.SHIELD_CLEARANCE ]: 0.8,
        [ EFFECT.LEGAL_DEFENSE ]: 0.5,
        [ EFFECT.SHARED_GENETIC_MEMORY ]: 0.5,
        [ EFFECT.DEMON_HUNTER ]: 0.5,
        [ EFFECT.SPIRIT_OF_JUSTICE ]: 0.5,
        [ EFFECT.HEIGHTENED_SENSES ]: 0.5,
        [ EFFECT.COMPETITION ]: 0.5,
        [ EFFECT.BANE_OF_HELLS_KITCHEN ]: 0.5,
        [ EFFECT.DEFENDERS_DESTROYER ]: 0.5,
        [ EFFECT.SPLIT_PERSONALITY ]: 0.5,
        [ EFFECT.ELECTRIC_SUPERCHARGE ]: 0.5,
        [ EFFECT.SEETHING_HATRED ]: 0.5,
        [ EFFECT.PARTICLE_PHYSICS ]: 0.5,
        [ EFFECT.ENGINEERING ]: 0.5,
        [ EFFECT.BIOCHEMISTRY ]: 0.5,
        [ EFFECT.AVENGERS_TRYOUT ]: 0.5,
        [ EFFECT.CONTEST_NOOBS ]: 0.5,
        [ EFFECT.KNOWLEDGE_SHARE ]: 0.5,
        [ EFFECT.MASTERS_OF_THE_SWORD ]: 0.5,
        [ EFFECT.SOUL_SEEKER ]: 0.5,
        [ EFFECT.WARRIOR_QUEENS ]: 0.5,
        [ EFFECT.LOYAL_MINISTER ]: 0.5,
        [ EFFECT.CROSS_TRAINING ]: 0.5,
        [ EFFECT.BELIEVER ]: 0.5,
        [ EFFECT.TEAM_BUILDING_EXERCISE ]: 0.5,
        [ EFFECT.LULLABY ]: 0.5,
        [ EFFECT.OFF_LIMITS ]: 0.5,
        [ EFFECT.PUNY_GOD ]: 0.5,
        [ EFFECT.OVERCOMING_FEAR ]: 0.5,
        [ EFFECT.LIKE_OLD_DAYS ]: 0.5,
        [ EFFECT.NOT_AFRAID_OF_DEATH ]: 0.5,
        [ EFFECT.FRIEND_FROM_WORK ]: 0.5,
        [ EFFECT.ADVANCED_IDEA_MECHANICS ]: 0.5,
        [ EFFECT.CHAIR_LARCENY ]: 0.5,
        [ EFFECT.IMMORTAL_SOULS ]: 0.5,
        [ EFFECT.QUEEN_OF_HEL ]: 0.5,
        [ EFFECT.HELL_LORDS ]: 0.5,
        [ EFFECT.CUBICLE_MATES ]: 0.5,
        [ EFFECT.OTHER_HALF ]: 0.5,
        [ EFFECT.TERMINATION_CONTRACT ]: 0.5,
        [ EFFECT.PROFESSORS_IN_CRIME ]: 0.5,
        [ EFFECT.MOSTLY_AVERAGE_JOES ]: 0.5,
        [ EFFECT.THUNDER ]: 0.5,
        [ EFFECT.TEAM_DEADPOOL_AWESOME_FORCE ]: 0.5,
        [ EFFECT.BROKEN_MINDS ]: 0.5,
        [ EFFECT.ANNOYANCES_ASSEMBLE ]: 0.5,
        [ EFFECT.SIX_PACK ]: 0.5,
        [ EFFECT.XFORCE ]: 0.5,
        [ EFFECT.WEAPON_X_STRIKE_TEAM ]: 0.5,
        [ EFFECT.CODE_RED_REVELATIONS ]: 0.5,
        [ EFFECT.MERCS_FOR_MONEY ]: 0.5,
        [ EFFECT.BETTER_LUCK_NEXT_TIME ]: 0.5,
        [ EFFECT.COMPLICATED ]: 0.5,
        [ EFFECT.ESOTERIC_INSIGHT ]: 0.5,
        [ EFFECT.COVERT_INSIGHT ]: 0.5,
        [ EFFECT.FAMILIAR_INSIGHT ]: 0.5,
        [ EFFECT.AI_UPGRADE ]: 0.5,
        [ EFFECT.WAKANDAN_INSIGHT ]: 0.5,
        [ EFFECT.ENHANCED_SOLDIERS ]: 0.5,
        [ EFFECT.WAKANDA_LEADERSHIP ]: 0.5,
        [ EFFECT.FEARLESS ]: 0.5,
        [ EFFECT.MUTANT_PURSUIT ]: 0.5,
        [ EFFECT.SKILL_TRAINING ]: 0.5,
        [ EFFECT.SCIENCE_RESEARCH ]: 0.5,
        [ EFFECT.MYSTIC_OBSERVATION ]: 0.5,
        [ EFFECT.TECH_ADVANCEMENT ]: 0.5,
        [ EFFECT.CHRONAL_ANCHOR ]: 0.5,
        [ EFFECT.ENERGY_CONDUIT ]: 0.5,
        [ EFFECT.DEMONS ]: 0.5,
        [ EFFECT.PACT_WITH_A_DEMON ]: 0.5,
        [ EFFECT.INHUMAN_ROYAL_FAMILY ]: 0.5,
        [ EFFECT.INSPIRATION ]: 0.5,
        [ EFFECT.GET_IN_THE_POOL ]: 0.5,
        [ EFFECT.SPIRITUAL_STRENGTH ]: 0.5,
        [ EFFECT.PLAYING_WITH_FIRE ]: 0.5,
        [ EFFECT.TECH_BREAKTHROUGH ]: 0.5,
        [ EFFECT.MUTANT_EVOLUTION ]: 0.5,
        [ EFFECT.SKILL_TRAINING_CAIW ]: 0.5,
        [ EFFECT.SCIENCE_EXPERIMENT ]: 0.5,
        [ EFFECT.MYSTIC_CRAFT ]: 0.5,
        [ EFFECT.COSMIC_POWER ]: 0.5,
        [ EFFECT.ADVANCED_TECH ]: 0.5,
        [ EFFECT.HARD_TO_HIT ]: 0.5,
        [ EFFECT.DEADLY_STING ]: 0.5,
        [ EFFECT.UNTAMED_FORCE ]: 0.5,
        [ EFFECT.DECIMATION ]: 0.5,
        [ EFFECT.NO_MERCY ]: 0.5,
        [ EFFECT.FORMIDABLE_FOE ]: 0.5,
        [ EFFECT.MICROSCOPIC_OBSERVATION ]: 0.5,
        [ EFFECT.THE_UNTOUCHABLES ]: 0.5,
        [ EFFECT.UNMERCIFUL_PUNISHMENT ]: 0.5,
        [ EFFECT.ASGARDIAN_HUNT ]: 0.5,
        [ EFFECT.SPECIAL_ASSIST ]: 0.5,
        [ EFFECT.HUNT_THE_UNCANNY ]: 0.5,
        [ EFFECT.CHALLENGE_DEFENSES ]: 0.5,
        [ EFFECT.GRIPPED_BY_FEAR ]: 0.5,
        [ EFFECT.ENGULFED_BY_THE_VOID ]: 0.5,
        [ EFFECT.ENCHANTED_BLADES ]: 0.5,
        [ EFFECT.LOST_DAUGHTERS_OF_ASGARD ]: 0.5,
        [ EFFECT.WARRIORS_OF_ASGARD ]: 0.5,
        [ EFFECT.PIT_FIGHTERS ]: 0.5,
        [ EFFECT.GRANDMASTERS_CHAMPIONS ]: 0.5,
        [ EFFECT.ELEMENTAL_HIDE ]: 0.5,
        [ EFFECT.DARK_ILLUMINATI ]: 0.5,
        [ EFFECT.ETERNAL_ADVERSARIES ]: 0.5,
        [ EFFECT.HAIL_HYDRA ]: 0.5,
        [ EFFECT.DARK_EMPOWERMENT ]: 0.5,
        [ EFFECT.METAL_MAYHEM ]: 0.5,
        [ EFFECT.XASSASSINS ]: 0.5,
        [ EFFECT.SEEING_RED ]: 0.5,
        [ EFFECT.DEADLY_PRESENCE ]: 0.5,
        [ EFFECT.MEMORIES_OF_GENOSHA ]: 0.5,
        [ EFFECT.IMPENETRABLE_HIDE ]: 0.5,
        [ EFFECT.ITS_COMPLICATED_2 ]: 0.5,
        [ EFFECT.PHOENIX_FORCE ]: 0.5,
        [ EFFECT.TOUGH_BRAWLERS ]: 0.5,
        [ EFFECT.PERSISTENT_FORCE ]: 0.5,
        [ EFFECT.COMBO_FIGHTER ]: 0.5,
        [ EFFECT.DAVID_AND_GOLIATH ]: 0.5,
        [ EFFECT.COMBO_BREAKERS ]: 0.5,
        [ EFFECT.WARRIORS_OF_THE_STARS ]: 0.5,
        [ EFFECT.FRIENDS ]: 0.5,
        [ EFFECT.SCHOOL_OF_HARD_ROCKS ]: 0.5,
        [ EFFECT.WORTHY_OPPONENT ]: 0.5,
        [ EFFECT.UNENDING_AMBITION ]: 0.5,
        [ EFFECT.MADCAP_EXPERIMENTALISTS ]: 0.5,
        [ EFFECT.TWISTED_ARCANISTS ]: 0.5,
        [ EFFECT.LEGION_ACCURSED ]: 0.5,
        [ EFFECT.GENETIC_RECODE_BARRIER ]: 0.5,
        [ EFFECT.GENETIC_RECODE_SURVIVAL ]: 0.5,
        [ EFFECT.GENETIC_RECODE_REGENESIS ]: 0.5,
        [ EFFECT.GENETIC_RECODE_EVOLUTION ]: 0.5,
        [ EFFECT.GENETIC_RECODE_HIVE_MIND ]: 0.5,
        [ EFFECT.GENETIC_RECODE_AGGRESSION ]: 0.5,
        [ EFFECT.GENETIC_RECODE_PROBABILITY ]: 0.5,
        [ EFFECT.GENETIC_RECODE_BLOODLETTING ]: 0.5,
        [ EFFECT.MYSTIC_MASTERS ]: 0.5,
        [ EFFECT.ANCIENT_HUNGER ]: 0.5,
        [ EFFECT.SUPREME_SYMBIOSIS ]: 0.5,
        [ EFFECT.MIDNIGHT_PURSUIT ]: 0.5,
        [ EFFECT.JUSTICE_ON_WHEELS ]: 0.5,
        [ EFFECT.CONTEST_TEAMMATES ]: 0.5,
        [ EFFECT.TACTICAL_TRAINING ]: 0.5,
        [ EFFECT.NIGHT_HAWKS ]: 0.5,
        [ EFFECT.DARK_JUSTICE ]: 0.5,
        [ EFFECT.BIRDS_OF_PREY ]: 0.5,
        [ EFFECT.RUNS_IN_THE_FAMILY ]: 0.5,
        [ EFFECT.OLD_TEAMMATES ]: 0.5,
        [ EFFECT.UNCANNY_AVENGERS ]: 0.5,
        [ EFFECT.GENETIC_MASTERPIECE ]: 0.5,
        [ EFFECT.MUTANT_DOMINION ]: 0.5,
        [ EFFECT.BLOOD_LINES ]: 0.5,
        [ EFFECT.MASTERMINDS_TWO ]: 0.5,
        [ EFFECT.STOLEN_MEMORIES ]: 0.5,
        [ EFFECT.PARTNERS_IN_SHIELD ]: 0.5,
        [ EFFECT.MARVELOUS ]: 0.5,
        [ EFFECT.FAN_CLUB ]: 0.5,
        [ EFFECT.RESTORATION_KIT ]: 0.5,
        [ EFFECT.STRATEGIC_SABOTAGE ]: 0.5,
        [ EFFECT.INCREASED_FIREPOWER ]: 0.5,
        [ EFFECT.CONTINGENCY_PLAN ]: 0.5,
        [ EFFECT.EXTREME_CONDITIONS_KIT ]: 0.5,
        [ EFFECT.POWER_KIT ]: 0.5,
        [ EFFECT.GWENOM_RISING ]: 0.5,
        [ EFFECT.AGENTS_OF_SMASH ]: 0.5,
        [ EFFECT.HUNTRESS_OF_THE_CONTEST ]: 0.5,
        [ EFFECT.SIBLING_RIVALRY ]: 0.5,
        [ EFFECT.CYBERNETICS_UPGRADE_ASSAULT ]: 0.5,
        [ EFFECT.CYBERNETICS_UPGRADE_TACTICS ]: 0.5,
        [ EFFECT.DOUBLE_NEGATIVE ]: 0.5,
        [ EFFECT.CHALLENGER ]: 0.5,
        [ EFFECT.RAIN_OF_FIRE ]: 0.5,
        [ EFFECT.TURN_UP_THE_HEAT ]: 0.5,
        [ EFFECT.A_SONG_OF_FIRE_AND_ICE ]: 0.5,
        [ EFFECT.FAMILIAR_FACES ]: 0.5,
        [ EFFECT.LAST_HOPE ]: 0.5,
        [ EFFECT.UNLIKELY_COMBINATION ]: 0.5,
        [ EFFECT.LIVE_AND_DIE_BY_THE_SWORD ]: 0.5,
        [ EFFECT.MASTERLESS ]: 0.5,
        [ EFFECT.LIEUTENANTS_OF_THE_BLACK_ORDER ]: 0.5,
        [ EFFECT.CULL_OF_THE_MAW ]: 0.5,
        [ EFFECT.INVASIVE_FORCE ]: 0.5,
        [ EFFECT.DISPLAY_OF_STRENGTH ]: 0.5,
        [ EFFECT.HEROES_NEVER_LEARN ]: 0.5,
        [ EFFECT.TIDE_TO_GO ]: 0.5,
        [ EFFECT.KINGS_OF_THE_WORLD ]: 0.5,
        [ EFFECT.BEACH_BODS ]: 0.5,
        [ EFFECT.FORCE_BLOCK ]: 0.5,
        [ EFFECT.TILL_DEATH ]: 0.5,
        [ EFFECT.UNPHASED ]: 0.5,
        [ EFFECT.ONE_WAY_OR_ANOTHER ]: 0.5,
        [ EFFECT.STARK_INTERNSHIP ]: 0.5,
        [ EFFECT.SPIDERMEN_IN_BLACK ]: 0.5,
        [ EFFECT.BAD_FOR_BUSINESS ]: 0.5,
        [ EFFECT.CULTURE_SHOCK ]: 0.5,
        [ EFFECT.MINE_CAN_HOVER ]: 0.5,
        [ EFFECT.ENCROACHING_INSANITY ]: 0.5,
        [ EFFECT.ENHANCED_ILLUSIONIST ]: 0.5,
        [ EFFECT.MENTAL_IMMUNITY ]: 0.5,
        [ EFFECT.NEW_MUTANTS ]: 0.5,
        [ EFFECT.AIM_TECHNOLOGY ]: 0.5,
        [ EFFECT.LEADING_AVENGERS ]: 0.5,
        [ EFFECT.SELFFRIENDS ]: 0.5,
        [ EFFECT.ROBOT_UPRISING ]: 0.5,
        [ EFFECT.GOING_VIRAL ]: 0.5,
        [ EFFECT.FIRST_OF_HIS_NAME ]: 0.5,
        [ EFFECT.DRY_ICE ]: 0.5,
        [ EFFECT.SENIORS_DISCOUNT ]: 0.5,
        [ EFFECT.JUDGEMENT_DAY ]: 0.5,
        [ EFFECT.A_SPELL_A_DAY_KEEPS_THE_DOCTOR_AWAY ]: 0.5,
        [ EFFECT.FIRE_AND_FORGET ]: 0.5,
        [ EFFECT.SPIDERS_BITE ]: 0.5,
        [ EFFECT.FEARSOME_FOUR ]: 0.5,
        [ EFFECT.BANE_OF_EVIL ]: 0.5,
        [ EFFECT.THINGS ]: 0.5,
        [ EFFECT.MISUNDERSTOOD_MONSTERS ]: 0.5,
        [ EFFECT.AI_UPRISING ]: 0.5,
        [ EFFECT.OUR_SHARED_CURSE ]: 0.5,
        [ EFFECT.HUNTING_PARTY ]: 0.5,
        [ EFFECT.BEAUTY_AND_THE_BEAST ]: 0.5,
        [ EFFECT.FANTASTIC_RAGE ]: 0.5,
        [ EFFECT.ENHANCED_FORCEFIELD ]: 0.5,
        [ EFFECT.GENIUS_INGENUITY ]: 0.5,
        [ EFFECT.SORCERY_REVERSAL ]: 0.5,
        [ EFFECT.COSMIC_OVERLOAD ]: 0.5,
        [ EFFECT.MYSTIC_TYRANTS ]: 0.5,
        [ EFFECT.HERBIE ]: 0.5,
        [ EFFECT.FANTASTIC_FOUR ]: 0.5,
        [ EFFECT.DO_US_PART ]: 0.5,
        [ EFFECT.COLLEGE_RIVALS ]: 0.5,
        [ EFFECT.SK_ASTRONOMY ]: 0.5,
        [ EFFECT.SK_ROBOTICS ]: 0.5,
        [ EFFECT.SK_GENETICS ]: 0.5,
        [ EFFECT.HERALDS_OF_GALACTUS ]: 0.5,
        [ EFFECT.SECRET_DEFENDERS ]: 0.5,
        [ EFFECT.MINE_TRAVELS_THROUGH_SPACE ]: 0.5,
        [ EFFECT.NEW_WARRIOR_BLOOD ]: 0.5,
        [ EFFECT.TOTAL_ANNIHILATION ]: 0.5,
        [ EFFECT.MAXIMUM_OUTPUT ]: 0.5,
        [ EFFECT.PHALANX_FEUD ]: 0.5,
        [ EFFECT.FULL_SPEED_AHEAD ]: 0.5,
        [ EFFECT.SUPERNANNY ]: 0.5,
        [ EFFECT.DEADPOOLS_GUIDE_TO_SUPER_VILLAINS ]: 0.5,
        [ EFFECT.HARDWIRED_FOR_HEARTBREAK ]: 0.5,
        [ EFFECT.BEAT_UP_THE_UNIVERSE ]: 0.5,
        [ EFFECT.MOJOVERSE ]: 0.5,
        [ EFFECT.SMILE_FOR_THE_CAMERAS ]: 0.5,
        [ EFFECT.WITHOUT_A_LEG_TO_STAND_ON ]: 0.5,
        [ EFFECT.CROWD_PLEASERS ]: 0.5,
        [ EFFECT.CIVIL_WAR_STORIES ]: 0.5,
        [ EFFECT.LOVE_TRIANGLES ]: 0.5,
        [ EFFECT.PROBABLY_OP ]: 0.5,
        [ EFFECT.GOOD_VIBRATIONS ]: 0.5,
        [ EFFECT.MONSTER_MASH ]: 0.5,
        [ EFFECT.FANTASTIC_FIENDS ]: 0.5,
        [ EFFECT.DEATH_AND_RESURRECTION ]: 0.5,
        [ EFFECT.ELDERS_GAME ]: 0.5,
        [ EFFECT.PRISONER ]: 0.5,
        [ EFFECT.A_GANG_OF ]: 0.5,
        [ EFFECT.LAB_PARTNERS ]: 0.5,
        [ EFFECT.TROPHY_CASE ]: 0.5,
        [ EFFECT.CHAMPIONS_OF_BATTLEWORLD ]: 0.5,
        [ EFFECT.DOCTORS_STRANGE ]: 0.5,
        [ EFFECT.MYSTIC_ARTS ]: 0.5,
        [ EFFECT.BLUETIFUL_PEOPLE ]: 0.5,
        [ EFFECT.GAMMA_HORDE ]: 0.5,
        [ EFFECT.HOUSE_OF_IRON ]: 0.5,
        [ EFFECT.SETUP_AND_SPIKE ]: 0.5,
        [ EFFECT.UNDER_THE_WEATHER ]: 0.5,
        [ EFFECT.KINGDOM_OF_WAKANDA ]: 0.5,
        [ EFFECT.SPIDERGUILD ]: 0.5,
        [ EFFECT.FAMILY_REUNION ]: 0.5,
        [ EFFECT.EASTERN_BLOCKERS ]: 0.5,
        [ EFFECT.LIVING_STEEL_CURTAIN ]: 0.5,
        [ EFFECT.MAGNIFICENT_MANES ]: 0.5,
        [ EFFECT.ENHANCED_WITH_CARBONADIUM ]: 0.5,
        [ EFFECT.REMEMBER_ME ]: 0.5,
        [ EFFECT.REMEMBERING_BUDAPEST ]: 0.5,
        [ EFFECT.COVERT_EXPERTISE ]: 0.5,
        [ EFFECT.WEST_COAST_AVENGERS ]: 0.5,
        [ EFFECT.FELINE_POSSESSION ]: 0.5,
        [ EFFECT.ENTREE ]: 0.5,
        [ EFFECT.BIG_GAME_HUNTERS ]: 0.5,
        [ EFFECT.NOT_THE_FACE ]: 0.5,
        [ EFFECT.SPIDER_MONKEY ]: 0.5,
        [ EFFECT.FURRY_FRENEMIES ]: 0.5,
        [ EFFECT.NO_EVIL ]: 0.5,
        [ EFFECT.ON_GUARD_FOR_THEE ]: 0.5,
        [ EFFECT.ALPHA_FLIGHT ]: 0.5,
        [ EFFECT.EXCAVATORS ]: 0.5,
        [ EFFECT.JUST_HAIR_AND_THINGS ]: 0.5,
        [ EFFECT.GAMMA_RAY_RAY ]: 0.5,
        [ EFFECT.FURRY_BUDS ]: 0.5,
        [ EFFECT.GIANT_CHALLENGERS ]: 0.5,
        [ EFFECT.COMMON_HISTORY ]: 0.5,
        [ EFFECT.NOVA_CORPS_VETERANS ]: 0.5,
        [ EFFECT.THE_HIGH_GROUND ]: 0.5,
        [ EFFECT.THE_FIRST_ONE ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_I ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_II ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_III ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_IV ]: 0.5,
        [ EFFECT.GUARDIAN_OF_THE_PYRAMID ]: 0.5,
        [ EFFECT.IMPENDING_STORM ]: 0.5,
        [ EFFECT.YOUR_FATE_IS_MINE ]: 0.5,
        [ EFFECT.CHAOTIC_ENERGY ]: 0.5,
        [ EFFECT.CROSSOVER ]: 0.5,
        [ EFFECT.DEATHWISH ]: 0.5,
        [ EFFECT.GOODFELLA ]: 0.5,
        [ EFFECT.MERC_WITH_A_MOUTH ]: 0.5,
        [ EFFECT.STUCK_IN_LIMBO ]: 0.5,
        [ EFFECT.DRUG_I ]: 0.5,
        [ EFFECT.DRUG_L ]: 0.5,
        [ EFFECT.DRUG_M ]: 0.5,
        [ EFFECT.GATEWAY ]: 0.5,
        [ EFFECT.HABITAT ]: 0.5,
        [ EFFECT.FIRST_CRUSH ]: 0.5,
        [ EFFECT.FULL_METAL ]: 0.5,
        [ EFFECT.NOT_SO_HIDDEN_DRAGON ]: 0.5,
        [ EFFECT.STUDENT_LOANS ]: 0.5,
        [ EFFECT.MY_BROTHERHOOD ]: 0.5,
        [ EFFECT.MY_CONTEST_NOW ]: 0.5,
        [ EFFECT.MY_HELLFIRE_CLUB ]: 0.5,
        [ EFFECT.MY_METALLIC_ANTIPATHY ]: 0.5,
        [ EFFECT.METALLIC_AFFINITY ]: 0.5,
        [ EFFECT.REDEMPTION ]: 0.5,
        [ EFFECT.RISE_AGAINST_THE_CONTEST ]: 0.5,
        [ EFFECT.FAMILY_FEUD ]: 0.5,
        [ EFFECT.HATRED ]: 0.5,
        [ EFFECT.OSBORN_TO_BE_WILD ]: 0.5,
        [ EFFECT.SELF_CENTERED ]: 0.5,
        [ EFFECT.SYMBIOTE_CONSCIOUSNESS ]: 0.5,
        [ EFFECT.COSMIC_BANE_OF_EVIL ]: 0.5,
        [ EFFECT.COSMIC_JUSTICE_ON_WHEELS ]: 0.5,
        [ EFFECT.PUNISHMENTS_OF_INFINITE_VARIETY ]: 0.5,
        [ EFFECT.SPIRITS_OF_VENGEANCE ]: 0.5,
        [ EFFECT.FASTBALL_SPECIAL ]: 0.5,
        [ EFFECT.FEEL_CYTORAKS_EMBRACE ]: 0.5,
        [ EFFECT.DONT_MENTION_PUNY_BANNER ]: 0.5,
        [ EFFECT.TECHNOLOGICAL_COMPETITION ]: 0.5,
        [ EFFECT.ENGINEERING_EXPERTS ]: 0.5,
        [ EFFECT.IT_AINT_EASY ]: 0.5,
        [ EFFECT.SINGULARITY ]: 0.5,
        [ EFFECT.ENHANCED_ADAMANTIUM ]: 0.5,
        [ EFFECT.NO_NOT_YOU ]: 0.5,
        [ EFFECT.THE_BRAVE_AND_THE_BOULDER ]: 0.5,
        [ EFFECT.PASSIVE_AGGRESSIVE ]: 0.5,
        [ EFFECT.ARACHNID_HUNTERS ]: 0.5,
        [ EFFECT.ALPHA_FLIGHT_SPACE_STATION ]: 0.5,
        [ EFFECT.GAMMA_MUTATES ]: 0.5,
        [ EFFECT.EXTREME_MEASURES ]: 0.5,
        [ EFFECT.HELL_AND_BACK ]: 0.5,
        [ EFFECT.FAIREST_OF_THEM_ALL ]: 0.5,
        [ EFFECT.ABOMINABLE_COMRADE ]: 0.5,
        [ EFFECT.IMMORTAL_RULERS ]: 0.5,
        [ EFFECT.IMMORTAL_KINGS ]: 0.5,
        [ EFFECT.TWO_DAYS_THIRTY_YEARS ]: 0.5,
        [ EFFECT.SATURDAY_MORNING_CARTOONS ]: 0.5,
        [ EFFECT.SWINESTER_SIX_MOST_WANTED ]: 0.5,
        [ EFFECT.FOURTH_WALL_CRAWLER ]: 0.5,
        [ EFFECT.FISK_DOWNFALL ]: 0.5,
        [ EFFECT.SECRET_OF_THE_HAND ]: 0.5,
        [ EFFECT.RULE_OF_LAW ]: 0.5,
        [ EFFECT.STRENGTH_OF_MARTYRS ]: 0.5,
        [ EFFECT.ALL_ADAMANTIUM_AND_ATTITUDE ]: 0.5,
        [ EFFECT.DEAL_WITH_IT ]: 0.5,
        [ EFFECT.EXECUTE_TARGET_ACQUISITION_SUBROUTINE ]: 0.5,
        [ EFFECT.PETITE ]: 0.5,
        [ EFFECT.THE_LUCKY_ONE ]: 0.5,
        [ EFFECT.YOURE_TANGLING_WITH_THE_WRONG_XMEN ]: 0.5,
        [ EFFECT.BIG_BAD_DAD ]: 0.5,
        [ EFFECT.BULL_TARGETS ]: 0.5,
        [ EFFECT.CLONED_AT_BIRTH ]: 0.5,
        [ EFFECT.MISS_ME ]: 0.5,
        [ EFFECT.HOSTILE_TAKEOVER ]: 0.5,
        [ EFFECT.WEDDING_CRASHER ]: 0.5,
        [ EFFECT.DINKY_SHRINKS ]: 0.5,
        [ EFFECT.MALICE ]: 0.5,
        [ EFFECT.PURE_HATRED ]: 0.5,
        [ EFFECT.THERE_GOES_THE_MULTIVERSE ]: 0.5,
        [ EFFECT.POWER_OF_MONEY ]: 0.5,
        [ EFFECT.REVOLUTIONS_NEED_ARMS ]: 0.5,
        [ EFFECT.AMBER_PRISON ]: 0.5,
        [ EFFECT.BANISHED ]: 0.5,
        [ EFFECT.ENERGY_ABSORPTION ]: 0.5,
        [ EFFECT.FUELED_WITH_RAGE ]: 0.5,
        [ EFFECT.RAGE_ON ]: 0.5,
        [ EFFECT.BATTLE_OF_REALMS ]: 0.5,
        [ EFFECT.OATHSWORN ]: 0.5,
        [ EFFECT.ODINSONS_AND_ODINSDOTTIRS ]: 0.5,
        [ EFFECT.WARMONGER ]: 0.5,
        [ EFFECT.HYDRA_RECRUITERS ]: 0.5,
        [ EFFECT.MERCENARY_COMPETITION ]: 0.5,
        [ EFFECT.CONTEMPTUOUS_HATRED ]: 0.5,
        [ EFFECT.WE_AINT_NO_PUNCHLINE ]: 0.5,
        [ EFFECT.NEW_YORK_BRAWLERS ]: 0.5,
        [ EFFECT.NOT_SO_UNCANNY ]: 0.5,
        [ EFFECT.IRON_MEN ]: 0.5,
        [ EFFECT.ASGARDIAN_REPUBLIC ]: 0.5,
        [ EFFECT.PATRIOT_GARRISON ]: 0.5,
        [ EFFECT.PET_PALS ]: 0.5,
        [ EFFECT.HUNTRESSES ]: 0.5,
        [ EFFECT.PYRAMID_X ]: 0.5,
        [ EFFECT.TEMPLE_OF_VISHANTI ]: 0.5,
        [ EFFECT.TRIBAL_WARFARE ]: 0.5,
        [ EFFECT.EYES_OF_THE_DRAGON ]: 0.5,
        [ EFFECT.MASTER_MARTIAL_ARTISTS ]: 0.5,
        [ EFFECT.SHADOWLAND ]: 0.5,
        [ EFFECT.THE_WAY_OF_THE_SPIDER ]: 0.5,
        [ EFFECT.A_BEING_DARKER_THAN_I ]: 0.5,
        [ EFFECT.FROM_LIGHT_TO_DARK ]: 0.5,
        [ EFFECT.HEALING_TOUCH ]: 0.5,
        [ EFFECT.TIME_WE_CHANGED_TOO ]: 0.5,
        [ EFFECT.BATTLEREALMS_CHANGING ]: 0.5,
        [ EFFECT.KINGS ]: 0.5,
        [ EFFECT.ROYALS ]: 0.5,
        [ EFFECT.WARRIORS ]: 0.5,
        [ EFFECT.DIMENSIONAL_BUDDIES ]: 0.5,
        [ EFFECT.MANY_AS_ONE ]: 0.5,
        [ EFFECT.POOR_UNFORTUNATE_SOUL ]: 0.5,
        [ EFFECT.QUEENS_OF_SOULS ]: 0.5,
        [ EFFECT.UNCHAINED ]: 0.5,
        [ EFFECT.WHAT_IF ]: 0.5,
        [ EFFECT.COSMIC_CONTROL ]: 0.5,
        [ EFFECT.CUBE_WIELDERS ]: 0.5,
        [ EFFECT.IDENTITY_DISORDER ]: 0.5,
        [ EFFECT.SHIELD_BUDDIES ]: 0.5,
        [ EFFECT.SPACE_SURFERS ]: 0.5,
        [ EFFECT.FORTIFY_ENHANCEMENT ]: 0.5,
        [ EFFECT.SKIRMISH_ENHANCEMENT ]: 0.5,
        [ EFFECT.SUPPORT_ENHANCEMENT ]: 0.5,
        [ EFFECT.MY_BEAUTIFUL_METEOR ]: 0.5,
        [ EFFECT.MY_WORLD_OF_METAL ]: 0.5,
        [ EFFECT.DECIMATION_SW ]: 0.5,
        [ EFFECT.CHAOS_RISING ]: 0.5,
        [ EFFECT.TILL_INFINITY_DO_US_PART ]: 0.5,
        [ EFFECT.DEMONIC_PACT ]: 0.5,
        [ EFFECT.SUPER_STARS ]: 0.5,
        [ EFFECT.OUT_OF_THIS_WORLD ]: 0.5,
        [ EFFECT.STAY_POSITIVE ]: 0.5,
        [ EFFECT.KO_QUEENS ]: 0.5,
        [ EFFECT.NEXT_ROUND_ON_ME ]: 0.5,
        [ EFFECT.MASTERFUL_COMBAT ]: 0.5,
        [ EFFECT.ARM_WRESTLING_CLUB ]: 0.5,
        [ EFFECT.PAWN_SET_FREE ]: 0.5,
        [ EFFECT.INCREDIBLE_SUBSTITUTE ]: 0.5,
        [ EFFECT.I_REQUIRE_THY_SHIELD ]: 0.5,
        [ EFFECT.START_WITH_FRESH_DEADPOOL ]: 0.5,
        [ EFFECT.ACCURATELY_MEASURE_INGREDIENTS ]: 0.5,
        [ EFFECT.BLEND_IN_SYMBIOTE ]: 0.5,
        [ EFFECT.ADD_PLAIN_WHITE_FLOUR ]: 0.5,
        [ EFFECT.FRY_IN_SKILLET ]: 0.5,
        [ EFFECT.ADJUST_COOKING_TIMER ]: 0.5,
        [ EFFECT.ALLOW_TO_COOL ]: 0.5,
        [ EFFECT.MUNCH_STUNNING_FOOD ]: 0.5,
        [ EFFECT.NOT_THE_HERO ]: 0.5,
        [ EFFECT.BUT_THE_BEST_VILLAIN ]: 0.5,
        [ EFFECT.CRIME_BOSSES ]: 0.5,
        [ EFFECT.CONTEMPTUOUS_MALICE ]: 0.5,
        [ EFFECT.GIANT_MONSTROSITIES ]: 0.5,
        [ EFFECT.ANGEL_ATTACK ]: 0.5,
        [ EFFECT.FIELD_TRIP ]: 0.5,
        [ EFFECT.SPIDERGEDDON ]: 0.5,
        [ EFFECT.STRANGE_BEASTS_AND_BIZARRE_MACHINES ]: 0.5,
        [ EFFECT.SUIT_UP ]: 0.5,
        [ EFFECT.TECHNICIAN ]: 0.5,
        [ EFFECT.AI_ENTHUSIASTS ]: 0.5,
        [ EFFECT.COWORKERS ]: 0.5,
        [ EFFECT.SPIDERVERSE_VETERANS ]: 0.5,
        [ EFFECT.SYMBIOTE_PROBLEMS ]: 0.5,
        [ EFFECT.WE_ARE_MANY ]: 0.5,
        [ EFFECT.ADVANCED_INTELLIGENCE ]: 0.5,
        // [ EFFECT.NEW_WAVE ]: 0.5,
        [ EFFECT.RESISTANCE_IS_FUTILE ]: 0.5,
        [ EFFECT.TERMINATED ]: 0.5,
        [ EFFECT.FIRE_AND_DRAGONS ]: 0.5,
        [ EFFECT.JUST_A_PHASE ]: 0.5,
        [ EFFECT.SHADOWY_HISTORY ]: 0.5,
        [ EFFECT.THROUGH_THICK_AND_THIN ]: 0.5,
        [ EFFECT.VICIOUS_KITTY ]: 0.5,
        [ EFFECT.WORTH_A_SHOT ]: 0.5,
        [ EFFECT.SPIDERSENSES_TINGLING ]: 0.5,
        [ EFFECT.SPIDERVERSE_MENTORS ]: 0.5,
        [ EFFECT.CYBERNETICS_UPGRADE_BLITZ ]: 0.5,
    },
    'balanced': {
        [ EFFECT.ATTACK ]: 0.5,
        [ EFFECT.IDOL ]: 0.5,
        [ EFFECT.INSEPARABLE ]: 0.5,
        [ EFFECT.MUTANT_AGENDA ]: 0.5,
        [ EFFECT.COSMIC_SUPREMACY ]: 0.5,
        [ EFFECT.CRITICAL_RATE ]: 0.5,
        [ EFFECT.CRITICAL_DAMAGE ]: 0.5,
        [ EFFECT.BLEED ]: 0.5,
        [ EFFECT.COMBO ]: 0.5,
        [ EFFECT.STUN_SPECIAL ]: 0.5,
        [ EFFECT.POWER_GAIN ]: 0.5,
        [ EFFECT.POWER_STEAL ]: 0.5,
        [ EFFECT.ITS_COMPLICATED ]: 0.5,
        [ EFFECT.PERFECT_BLOCK ]: 0.5,
        [ EFFECT.ARMOR ]: 0.5,
        [ EFFECT.HEALTH ]: 0.5,
        [ EFFECT.HEALTH_STEAL ]: 0.5,
        [ EFFECT.HEROES_FOR_HIRE ]: 0.5,
        [ EFFECT.THUNDERBOLTS ]: 0.5,
        [ EFFECT.MASTERMINDS ]: 0.5,
        [ EFFECT.SHIELD_AGENTS ]: 0.5,
        [ EFFECT.SHIELD_CLEARANCE ]: 0.5,
        [ EFFECT.LEGAL_DEFENSE ]: 0.5,
        [ EFFECT.SHARED_GENETIC_MEMORY ]: 0.5,
        [ EFFECT.DEMON_HUNTER ]: 0.5,
        [ EFFECT.SPIRIT_OF_JUSTICE ]: 0.5,
        [ EFFECT.HEIGHTENED_SENSES ]: 0.5,
        [ EFFECT.COMPETITION ]: 0.5,
        [ EFFECT.BANE_OF_HELLS_KITCHEN ]: 0.5,
        [ EFFECT.DEFENDERS_DESTROYER ]: 0.5,
        [ EFFECT.SPLIT_PERSONALITY ]: 0.5,
        [ EFFECT.ELECTRIC_SUPERCHARGE ]: 0.5,
        [ EFFECT.SEETHING_HATRED ]: 0.5,
        [ EFFECT.PARTICLE_PHYSICS ]: 0.5,
        [ EFFECT.ENGINEERING ]: 0.5,
        [ EFFECT.BIOCHEMISTRY ]: 0.5,
        [ EFFECT.AVENGERS_TRYOUT ]: 0.5,
        [ EFFECT.CONTEST_NOOBS ]: 0.5,
        [ EFFECT.KNOWLEDGE_SHARE ]: 0.5,
        [ EFFECT.MASTERS_OF_THE_SWORD ]: 0.5,
        [ EFFECT.SOUL_SEEKER ]: 0.5,
        [ EFFECT.WARRIOR_QUEENS ]: 0.5,
        [ EFFECT.LOYAL_MINISTER ]: 0.5,
        [ EFFECT.CROSS_TRAINING ]: 0.5,
        [ EFFECT.BELIEVER ]: 0.5,
        [ EFFECT.TEAM_BUILDING_EXERCISE ]: 0.5,
        [ EFFECT.LULLABY ]: 0.5,
        [ EFFECT.OFF_LIMITS ]: 0.5,
        [ EFFECT.PUNY_GOD ]: 0.5,
        [ EFFECT.OVERCOMING_FEAR ]: 0.5,
        [ EFFECT.LIKE_OLD_DAYS ]: 0.5,
        [ EFFECT.NOT_AFRAID_OF_DEATH ]: 0.5,
        [ EFFECT.FRIEND_FROM_WORK ]: 0.5,
        [ EFFECT.ADVANCED_IDEA_MECHANICS ]: 0.5,
        [ EFFECT.CHAIR_LARCENY ]: 0.5,
        [ EFFECT.IMMORTAL_SOULS ]: 0.5,
        [ EFFECT.QUEEN_OF_HEL ]: 0.5,
        [ EFFECT.HELL_LORDS ]: 0.5,
        [ EFFECT.CUBICLE_MATES ]: 0.5,
        [ EFFECT.OTHER_HALF ]: 0.5,
        [ EFFECT.TERMINATION_CONTRACT ]: 0.5,
        [ EFFECT.PROFESSORS_IN_CRIME ]: 0.5,
        [ EFFECT.MOSTLY_AVERAGE_JOES ]: 0.5,
        [ EFFECT.THUNDER ]: 0.5,
        [ EFFECT.TEAM_DEADPOOL_AWESOME_FORCE ]: 0.5,
        [ EFFECT.BROKEN_MINDS ]: 0.5,
        [ EFFECT.ANNOYANCES_ASSEMBLE ]: 0.5,
        [ EFFECT.SIX_PACK ]: 0.5,
        [ EFFECT.XFORCE ]: 0.5,
        [ EFFECT.WEAPON_X_STRIKE_TEAM ]: 0.5,
        [ EFFECT.CODE_RED_REVELATIONS ]: 0.5,
        [ EFFECT.MERCS_FOR_MONEY ]: 0.5,
        [ EFFECT.BETTER_LUCK_NEXT_TIME ]: 0.5,
        [ EFFECT.COMPLICATED ]: 0.5,
        [ EFFECT.ESOTERIC_INSIGHT ]: 0.5,
        [ EFFECT.COVERT_INSIGHT ]: 0.5,
        [ EFFECT.FAMILIAR_INSIGHT ]: 0.5,
        [ EFFECT.AI_UPGRADE ]: 0.5,
        [ EFFECT.WAKANDAN_INSIGHT ]: 0.5,
        [ EFFECT.ENHANCED_SOLDIERS ]: 0.5,
        [ EFFECT.WAKANDA_LEADERSHIP ]: 0.5,
        [ EFFECT.FEARLESS ]: 0.5,
        [ EFFECT.MUTANT_PURSUIT ]: 0.5,
        [ EFFECT.SKILL_TRAINING ]: 0.5,
        [ EFFECT.SCIENCE_RESEARCH ]: 0.5,
        [ EFFECT.MYSTIC_OBSERVATION ]: 0.5,
        [ EFFECT.TECH_ADVANCEMENT ]: 0.5,
        [ EFFECT.CHRONAL_ANCHOR ]: 0.5,
        [ EFFECT.ENERGY_CONDUIT ]: 0.5,
        [ EFFECT.DEMONS ]: 0.5,
        [ EFFECT.PACT_WITH_A_DEMON ]: 0.5,
        [ EFFECT.INHUMAN_ROYAL_FAMILY ]: 0.5,
        [ EFFECT.INSPIRATION ]: 0.5,
        [ EFFECT.GET_IN_THE_POOL ]: 0.5,
        [ EFFECT.SPIRITUAL_STRENGTH ]: 0.5,
        [ EFFECT.PLAYING_WITH_FIRE ]: 0.5,
        [ EFFECT.TECH_BREAKTHROUGH ]: 0.5,
        [ EFFECT.MUTANT_EVOLUTION ]: 0.5,
        [ EFFECT.SKILL_TRAINING_CAIW ]: 0.5,
        [ EFFECT.SCIENCE_EXPERIMENT ]: 0.5,
        [ EFFECT.MYSTIC_CRAFT ]: 0.5,
        [ EFFECT.COSMIC_POWER ]: 0.5,
        [ EFFECT.ADVANCED_TECH ]: 0.5,
        [ EFFECT.HARD_TO_HIT ]: 0.5,
        [ EFFECT.DEADLY_STING ]: 0.5,
        [ EFFECT.UNTAMED_FORCE ]: 0.5,
        [ EFFECT.DECIMATION ]: 0.5,
        [ EFFECT.NO_MERCY ]: 0.5,
        [ EFFECT.FORMIDABLE_FOE ]: 0.5,
        [ EFFECT.MICROSCOPIC_OBSERVATION ]: 0.5,
        [ EFFECT.THE_UNTOUCHABLES ]: 0.5,
        [ EFFECT.UNMERCIFUL_PUNISHMENT ]: 0.5,
        [ EFFECT.ASGARDIAN_HUNT ]: 0.5,
        [ EFFECT.SPECIAL_ASSIST ]: 0.5,
        [ EFFECT.HUNT_THE_UNCANNY ]: 0.5,
        [ EFFECT.CHALLENGE_DEFENSES ]: 0.5,
        [ EFFECT.GRIPPED_BY_FEAR ]: 0.5,
        [ EFFECT.ENGULFED_BY_THE_VOID ]: 0.5,
        [ EFFECT.ENCHANTED_BLADES ]: 0.5,
        [ EFFECT.LOST_DAUGHTERS_OF_ASGARD ]: 0.5,
        [ EFFECT.WARRIORS_OF_ASGARD ]: 0.5,
        [ EFFECT.PIT_FIGHTERS ]: 0.5,
        [ EFFECT.GRANDMASTERS_CHAMPIONS ]: 0.5,
        [ EFFECT.ELEMENTAL_HIDE ]: 0.5,
        [ EFFECT.DARK_ILLUMINATI ]: 0.5,
        [ EFFECT.ETERNAL_ADVERSARIES ]: 0.5,
        [ EFFECT.HAIL_HYDRA ]: 0.5,
        [ EFFECT.DARK_EMPOWERMENT ]: 0.5,
        [ EFFECT.METAL_MAYHEM ]: 0.5,
        [ EFFECT.XASSASSINS ]: 0.5,
        [ EFFECT.SEEING_RED ]: 0.5,
        [ EFFECT.DEADLY_PRESENCE ]: 0.5,
        [ EFFECT.MEMORIES_OF_GENOSHA ]: 0.5,
        [ EFFECT.IMPENETRABLE_HIDE ]: 0.5,
        [ EFFECT.ITS_COMPLICATED_2 ]: 0.5,
        [ EFFECT.PHOENIX_FORCE ]: 0.5,
        [ EFFECT.TOUGH_BRAWLERS ]: 0.5,
        [ EFFECT.PERSISTENT_FORCE ]: 0.5,
        [ EFFECT.COMBO_FIGHTER ]: 0.5,
        [ EFFECT.DAVID_AND_GOLIATH ]: 0.5,
        [ EFFECT.COMBO_BREAKERS ]: 0.5,
        [ EFFECT.WARRIORS_OF_THE_STARS ]: 0.5,
        [ EFFECT.FRIENDS ]: 0.5,
        [ EFFECT.SCHOOL_OF_HARD_ROCKS ]: 0.5,
        [ EFFECT.WORTHY_OPPONENT ]: 0.5,
        [ EFFECT.UNENDING_AMBITION ]: 0.5,
        [ EFFECT.MADCAP_EXPERIMENTALISTS ]: 0.5,
        [ EFFECT.TWISTED_ARCANISTS ]: 0.5,
        [ EFFECT.LEGION_ACCURSED ]: 0.5,
        [ EFFECT.GENETIC_RECODE_BARRIER ]: 0.5,
        [ EFFECT.GENETIC_RECODE_SURVIVAL ]: 0.5,
        [ EFFECT.GENETIC_RECODE_REGENESIS ]: 0.5,
        [ EFFECT.GENETIC_RECODE_EVOLUTION ]: 0.5,
        [ EFFECT.GENETIC_RECODE_HIVE_MIND ]: 0.5,
        [ EFFECT.GENETIC_RECODE_AGGRESSION ]: 0.5,
        [ EFFECT.GENETIC_RECODE_PROBABILITY ]: 0.5,
        [ EFFECT.GENETIC_RECODE_BLOODLETTING ]: 0.5,
        [ EFFECT.MYSTIC_MASTERS ]: 0.5,
        [ EFFECT.ANCIENT_HUNGER ]: 0.5,
        [ EFFECT.SUPREME_SYMBIOSIS ]: 0.5,
        [ EFFECT.MIDNIGHT_PURSUIT ]: 0.5,
        [ EFFECT.JUSTICE_ON_WHEELS ]: 0.5,
        [ EFFECT.CONTEST_TEAMMATES ]: 0.5,
        [ EFFECT.TACTICAL_TRAINING ]: 0.5,
        [ EFFECT.NIGHT_HAWKS ]: 0.5,
        [ EFFECT.DARK_JUSTICE ]: 0.5,
        [ EFFECT.BIRDS_OF_PREY ]: 0.5,
        [ EFFECT.RUNS_IN_THE_FAMILY ]: 0.5,
        [ EFFECT.OLD_TEAMMATES ]: 0.5,
        [ EFFECT.UNCANNY_AVENGERS ]: 0.5,
        [ EFFECT.GENETIC_MASTERPIECE ]: 0.5,
        [ EFFECT.MUTANT_DOMINION ]: 0.5,
        [ EFFECT.BLOOD_LINES ]: 0.5,
        [ EFFECT.MASTERMINDS_TWO ]: 0.5,
        [ EFFECT.STOLEN_MEMORIES ]: 0.5,
        [ EFFECT.PARTNERS_IN_SHIELD ]: 0.5,
        [ EFFECT.MARVELOUS ]: 0.5,
        [ EFFECT.FAN_CLUB ]: 0.5,
        [ EFFECT.RESTORATION_KIT ]: 0.5,
        [ EFFECT.STRATEGIC_SABOTAGE ]: 0.5,
        [ EFFECT.INCREASED_FIREPOWER ]: 0.5,
        [ EFFECT.CONTINGENCY_PLAN ]: 0.5,
        [ EFFECT.EXTREME_CONDITIONS_KIT ]: 0.5,
        [ EFFECT.POWER_KIT ]: 0.5,
        [ EFFECT.GWENOM_RISING ]: 0.5,
        [ EFFECT.AGENTS_OF_SMASH ]: 0.5,
        [ EFFECT.HUNTRESS_OF_THE_CONTEST ]: 0.5,
        [ EFFECT.SIBLING_RIVALRY ]: 0.5,
        [ EFFECT.CYBERNETICS_UPGRADE_ASSAULT ]: 0.5,
        [ EFFECT.CYBERNETICS_UPGRADE_TACTICS ]: 0.5,
        [ EFFECT.DOUBLE_NEGATIVE ]: 0.5,
        [ EFFECT.CHALLENGER ]: 0.5,
        [ EFFECT.RAIN_OF_FIRE ]: 0.5,
        [ EFFECT.TURN_UP_THE_HEAT ]: 0.5,
        [ EFFECT.A_SONG_OF_FIRE_AND_ICE ]: 0.5,
        [ EFFECT.FAMILIAR_FACES ]: 0.5,
        [ EFFECT.LAST_HOPE ]: 0.5,
        [ EFFECT.UNLIKELY_COMBINATION ]: 0.5,
        [ EFFECT.LIVE_AND_DIE_BY_THE_SWORD ]: 0.5,
        [ EFFECT.MASTERLESS ]: 0.5,
        [ EFFECT.LIEUTENANTS_OF_THE_BLACK_ORDER ]: 0.5,
        [ EFFECT.CULL_OF_THE_MAW ]: 0.5,
        [ EFFECT.INVASIVE_FORCE ]: 0.5,
        [ EFFECT.DISPLAY_OF_STRENGTH ]: 0.5,
        [ EFFECT.HEROES_NEVER_LEARN ]: 0.5,
        [ EFFECT.TIDE_TO_GO ]: 0.5,
        [ EFFECT.KINGS_OF_THE_WORLD ]: 0.5,
        [ EFFECT.BEACH_BODS ]: 0.5,
        [ EFFECT.FORCE_BLOCK ]: 0.5,
        [ EFFECT.TILL_DEATH ]: 0.5,
        [ EFFECT.UNPHASED ]: 0.5,
        [ EFFECT.ONE_WAY_OR_ANOTHER ]: 0.5,
        [ EFFECT.STARK_INTERNSHIP ]: 0.5,
        [ EFFECT.SPIDERMEN_IN_BLACK ]: 0.5,
        [ EFFECT.BAD_FOR_BUSINESS ]: 0.5,
        [ EFFECT.CULTURE_SHOCK ]: 0.5,
        [ EFFECT.MINE_CAN_HOVER ]: 0.5,
        [ EFFECT.ENCROACHING_INSANITY ]: 0.5,
        [ EFFECT.ENHANCED_ILLUSIONIST ]: 0.5,
        [ EFFECT.MENTAL_IMMUNITY ]: 0.5,
        [ EFFECT.NEW_MUTANTS ]: 0.5,
        [ EFFECT.AIM_TECHNOLOGY ]: 0.5,
        [ EFFECT.LEADING_AVENGERS ]: 0.5,
        [ EFFECT.SELFFRIENDS ]: 0.5,
        [ EFFECT.ROBOT_UPRISING ]: 0.5,
        [ EFFECT.GOING_VIRAL ]: 0.5,
        [ EFFECT.FIRST_OF_HIS_NAME ]: 0.5,
        [ EFFECT.DRY_ICE ]: 0.5,
        [ EFFECT.SENIORS_DISCOUNT ]: 0.5,
        [ EFFECT.JUDGEMENT_DAY ]: 0.5,
        [ EFFECT.A_SPELL_A_DAY_KEEPS_THE_DOCTOR_AWAY ]: 0.5,
        [ EFFECT.FIRE_AND_FORGET ]: 0.5,
        [ EFFECT.SPIDERS_BITE ]: 0.5,
        [ EFFECT.FEARSOME_FOUR ]: 0.5,
        [ EFFECT.BANE_OF_EVIL ]: 0.5,
        [ EFFECT.THINGS ]: 0.5,
        [ EFFECT.MISUNDERSTOOD_MONSTERS ]: 0.5,
        [ EFFECT.AI_UPRISING ]: 0.5,
        [ EFFECT.OUR_SHARED_CURSE ]: 0.5,
        [ EFFECT.HUNTING_PARTY ]: 0.5,
        [ EFFECT.BEAUTY_AND_THE_BEAST ]: 0.5,
        [ EFFECT.FANTASTIC_RAGE ]: 0.5,
        [ EFFECT.ENHANCED_FORCEFIELD ]: 0.5,
        [ EFFECT.GENIUS_INGENUITY ]: 0.5,
        [ EFFECT.SORCERY_REVERSAL ]: 0.5,
        [ EFFECT.COSMIC_OVERLOAD ]: 0.5,
        [ EFFECT.MYSTIC_TYRANTS ]: 0.5,
        [ EFFECT.HERBIE ]: 0.5,
        [ EFFECT.FANTASTIC_FOUR ]: 0.5,
        [ EFFECT.DO_US_PART ]: 0.5,
        [ EFFECT.COLLEGE_RIVALS ]: 0.5,
        [ EFFECT.SK_ASTRONOMY ]: 0.5,
        [ EFFECT.SK_ROBOTICS ]: 0.5,
        [ EFFECT.SK_GENETICS ]: 0.5,
        [ EFFECT.HERALDS_OF_GALACTUS ]: 0.5,
        [ EFFECT.SECRET_DEFENDERS ]: 0.5,
        [ EFFECT.MINE_TRAVELS_THROUGH_SPACE ]: 0.5,
        [ EFFECT.NEW_WARRIOR_BLOOD ]: 0.5,
        [ EFFECT.TOTAL_ANNIHILATION ]: 0.5,
        [ EFFECT.MAXIMUM_OUTPUT ]: 0.5,
        [ EFFECT.PHALANX_FEUD ]: 0.5,
        [ EFFECT.FULL_SPEED_AHEAD ]: 0.5,
        [ EFFECT.SUPERNANNY ]: 0.5,
        [ EFFECT.DEADPOOLS_GUIDE_TO_SUPER_VILLAINS ]: 0.5,
        [ EFFECT.HARDWIRED_FOR_HEARTBREAK ]: 0.5,
        [ EFFECT.BEAT_UP_THE_UNIVERSE ]: 0.5,
        [ EFFECT.MOJOVERSE ]: 0.5,
        [ EFFECT.SMILE_FOR_THE_CAMERAS ]: 0.5,
        [ EFFECT.WITHOUT_A_LEG_TO_STAND_ON ]: 0.5,
        [ EFFECT.CROWD_PLEASERS ]: 0.5,
        [ EFFECT.CIVIL_WAR_STORIES ]: 0.5,
        [ EFFECT.LOVE_TRIANGLES ]: 0.5,
        [ EFFECT.PROBABLY_OP ]: 0.5,
        [ EFFECT.GOOD_VIBRATIONS ]: 0.5,
        [ EFFECT.MONSTER_MASH ]: 0.5,
        [ EFFECT.FANTASTIC_FIENDS ]: 0.5,
        [ EFFECT.DEATH_AND_RESURRECTION ]: 0.5,
        [ EFFECT.ELDERS_GAME ]: 0.5,
        [ EFFECT.PRISONER ]: 0.5,
        [ EFFECT.A_GANG_OF ]: 0.5,
        [ EFFECT.LAB_PARTNERS ]: 0.5,
        [ EFFECT.TROPHY_CASE ]: 0.5,
        [ EFFECT.CHAMPIONS_OF_BATTLEWORLD ]: 0.5,
        [ EFFECT.DOCTORS_STRANGE ]: 0.5,
        [ EFFECT.MYSTIC_ARTS ]: 0.5,
        [ EFFECT.BLUETIFUL_PEOPLE ]: 0.5,
        [ EFFECT.GAMMA_HORDE ]: 0.5,
        [ EFFECT.HOUSE_OF_IRON ]: 0.5,
        [ EFFECT.SETUP_AND_SPIKE ]: 0.5,
        [ EFFECT.UNDER_THE_WEATHER ]: 0.5,
        [ EFFECT.KINGDOM_OF_WAKANDA ]: 0.5,
        [ EFFECT.SPIDERGUILD ]: 0.5,
        [ EFFECT.FAMILY_REUNION ]: 0.5,
        [ EFFECT.EASTERN_BLOCKERS ]: 0.5,
        [ EFFECT.LIVING_STEEL_CURTAIN ]: 0.5,
        [ EFFECT.MAGNIFICENT_MANES ]: 0.5,
        [ EFFECT.ENHANCED_WITH_CARBONADIUM ]: 0.5,
        [ EFFECT.REMEMBER_ME ]: 0.5,
        [ EFFECT.REMEMBERING_BUDAPEST ]: 0.5,
        [ EFFECT.COVERT_EXPERTISE ]: 0.5,
        [ EFFECT.WEST_COAST_AVENGERS ]: 0.5,
        [ EFFECT.FELINE_POSSESSION ]: 0.5,
        [ EFFECT.ENTREE ]: 0.5,
        [ EFFECT.BIG_GAME_HUNTERS ]: 0.5,
        [ EFFECT.NOT_THE_FACE ]: 0.5,
        [ EFFECT.SPIDER_MONKEY ]: 0.5,
        [ EFFECT.FURRY_FRENEMIES ]: 0.5,
        [ EFFECT.NO_EVIL ]: 0.5,
        [ EFFECT.ON_GUARD_FOR_THEE ]: 0.5,
        [ EFFECT.ALPHA_FLIGHT ]: 0.5,
        [ EFFECT.EXCAVATORS ]: 0.5,
        [ EFFECT.JUST_HAIR_AND_THINGS ]: 0.5,
        [ EFFECT.GAMMA_RAY_RAY ]: 0.5,
        [ EFFECT.FURRY_BUDS ]: 0.5,
        [ EFFECT.GIANT_CHALLENGERS ]: 0.5,
        [ EFFECT.COMMON_HISTORY ]: 0.5,
        [ EFFECT.NOVA_CORPS_VETERANS ]: 0.5,
        [ EFFECT.THE_HIGH_GROUND ]: 0.5,
        [ EFFECT.THE_FIRST_ONE ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_I ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_II ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_III ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_IV ]: 0.5,
        [ EFFECT.GUARDIAN_OF_THE_PYRAMID ]: 0.5,
        [ EFFECT.IMPENDING_STORM ]: 0.5,
        [ EFFECT.YOUR_FATE_IS_MINE ]: 0.5,
        [ EFFECT.CHAOTIC_ENERGY ]: 0.5,
        [ EFFECT.CROSSOVER ]: 0.5,
        [ EFFECT.DEATHWISH ]: 0.5,
        [ EFFECT.GOODFELLA ]: 0.5,
        [ EFFECT.MERC_WITH_A_MOUTH ]: 0.5,
        [ EFFECT.STUCK_IN_LIMBO ]: 0.5,
        [ EFFECT.DRUG_I ]: 0.5,
        [ EFFECT.DRUG_L ]: 0.5,
        [ EFFECT.DRUG_M ]: 0.5,
        [ EFFECT.GATEWAY ]: 0.5,
        [ EFFECT.HABITAT ]: 0.5,
        [ EFFECT.FIRST_CRUSH ]: 0.5,
        [ EFFECT.FULL_METAL ]: 0.5,
        [ EFFECT.NOT_SO_HIDDEN_DRAGON ]: 0.5,
        [ EFFECT.STUDENT_LOANS ]: 0.5,
        [ EFFECT.MY_BROTHERHOOD ]: 0.5,
        [ EFFECT.MY_CONTEST_NOW ]: 0.5,
        [ EFFECT.MY_HELLFIRE_CLUB ]: 0.5,
        [ EFFECT.MY_METALLIC_ANTIPATHY ]: 0.5,
        [ EFFECT.METALLIC_AFFINITY ]: 0.5,
        [ EFFECT.REDEMPTION ]: 0.5,
        [ EFFECT.RISE_AGAINST_THE_CONTEST ]: 0.5,
        [ EFFECT.FAMILY_FEUD ]: 0.5,
        [ EFFECT.HATRED ]: 0.5,
        [ EFFECT.OSBORN_TO_BE_WILD ]: 0.5,
        [ EFFECT.SELF_CENTERED ]: 0.5,
        [ EFFECT.SYMBIOTE_CONSCIOUSNESS ]: 0.5,
        [ EFFECT.COSMIC_BANE_OF_EVIL ]: 0.5,
        [ EFFECT.COSMIC_JUSTICE_ON_WHEELS ]: 0.5,
        [ EFFECT.PUNISHMENTS_OF_INFINITE_VARIETY ]: 0.5,
        [ EFFECT.SPIRITS_OF_VENGEANCE ]: 0.5,
        [ EFFECT.FASTBALL_SPECIAL ]: 0.5,
        [ EFFECT.FEEL_CYTORAKS_EMBRACE ]: 0.5,
        [ EFFECT.DONT_MENTION_PUNY_BANNER ]: 0.5,
        [ EFFECT.TECHNOLOGICAL_COMPETITION ]: 0.5,
        [ EFFECT.ENGINEERING_EXPERTS ]: 0.5,
        [ EFFECT.IT_AINT_EASY ]: 0.5,
        [ EFFECT.SINGULARITY ]: 0.5,
        [ EFFECT.ENHANCED_ADAMANTIUM ]: 0.5,
        [ EFFECT.NO_NOT_YOU ]: 0.5,
        [ EFFECT.THE_BRAVE_AND_THE_BOULDER ]: 0.5,
        [ EFFECT.PASSIVE_AGGRESSIVE ]: 0.5,
        [ EFFECT.ARACHNID_HUNTERS ]: 0.5,
        [ EFFECT.ALPHA_FLIGHT_SPACE_STATION ]: 0.5,
        [ EFFECT.GAMMA_MUTATES ]: 0.5,
        [ EFFECT.EXTREME_MEASURES ]: 0.5,
        [ EFFECT.HELL_AND_BACK ]: 0.5,
        [ EFFECT.FAIREST_OF_THEM_ALL ]: 0.5,
        [ EFFECT.ABOMINABLE_COMRADE ]: 0.5,
        [ EFFECT.IMMORTAL_RULERS ]: 0.5,
        [ EFFECT.IMMORTAL_KINGS ]: 0.5,
        [ EFFECT.TWO_DAYS_THIRTY_YEARS ]: 0.5,
        [ EFFECT.SATURDAY_MORNING_CARTOONS ]: 0.5,
        [ EFFECT.SWINESTER_SIX_MOST_WANTED ]: 0.5,
        [ EFFECT.FOURTH_WALL_CRAWLER ]: 0.5,
        [ EFFECT.FISK_DOWNFALL ]: 0.5,
        [ EFFECT.SECRET_OF_THE_HAND ]: 0.5,
        [ EFFECT.RULE_OF_LAW ]: 0.5,
        [ EFFECT.STRENGTH_OF_MARTYRS ]: 0.5,
        [ EFFECT.ALL_ADAMANTIUM_AND_ATTITUDE ]: 0.5,
        [ EFFECT.DEAL_WITH_IT ]: 0.5,
        [ EFFECT.EXECUTE_TARGET_ACQUISITION_SUBROUTINE ]: 0.5,
        [ EFFECT.PETITE ]: 0.5,
        [ EFFECT.THE_LUCKY_ONE ]: 0.5,
        [ EFFECT.YOURE_TANGLING_WITH_THE_WRONG_XMEN ]: 0.5,
        [ EFFECT.BIG_BAD_DAD ]: 0.5,
        [ EFFECT.BULL_TARGETS ]: 0.5,
        [ EFFECT.CLONED_AT_BIRTH ]: 0.5,
        [ EFFECT.MISS_ME ]: 0.5,
        [ EFFECT.HOSTILE_TAKEOVER ]: 0.5,
        [ EFFECT.WEDDING_CRASHER ]: 0.5,
        [ EFFECT.DINKY_SHRINKS ]: 0.5,
        [ EFFECT.MALICE ]: 0.5,
        [ EFFECT.PURE_HATRED ]: 0.5,
        [ EFFECT.THERE_GOES_THE_MULTIVERSE ]: 0.5,
        [ EFFECT.POWER_OF_MONEY ]: 0.5,
        [ EFFECT.REVOLUTIONS_NEED_ARMS ]: 0.5,
        [ EFFECT.AMBER_PRISON ]: 0.5,
        [ EFFECT.BANISHED ]: 0.5,
        [ EFFECT.ENERGY_ABSORPTION ]: 0.5,
        [ EFFECT.FUELED_WITH_RAGE ]: 0.5,
        [ EFFECT.RAGE_ON ]: 0.5,
        [ EFFECT.BATTLE_OF_REALMS ]: 0.5,
        [ EFFECT.OATHSWORN ]: 0.5,
        [ EFFECT.ODINSONS_AND_ODINSDOTTIRS ]: 0.5,
        [ EFFECT.WARMONGER ]: 0.5,
        [ EFFECT.HYDRA_RECRUITERS ]: 0.5,
        [ EFFECT.MERCENARY_COMPETITION ]: 0.5,
        [ EFFECT.CONTEMPTUOUS_HATRED ]: 0.5,
        [ EFFECT.WE_AINT_NO_PUNCHLINE ]: 0.5,
        [ EFFECT.NEW_YORK_BRAWLERS ]: 0.5,
        [ EFFECT.NOT_SO_UNCANNY ]: 0.5,
        [ EFFECT.IRON_MEN ]: 0.5,
        [ EFFECT.ASGARDIAN_REPUBLIC ]: 0.5,
        [ EFFECT.PATRIOT_GARRISON ]: 0.5,
        [ EFFECT.PET_PALS ]: 0.5,
        [ EFFECT.HUNTRESSES ]: 0.5,
        [ EFFECT.PYRAMID_X ]: 0.5,
        [ EFFECT.TEMPLE_OF_VISHANTI ]: 0.5,
        [ EFFECT.TRIBAL_WARFARE ]: 0.5,
        [ EFFECT.EYES_OF_THE_DRAGON ]: 0.5,
        [ EFFECT.MASTER_MARTIAL_ARTISTS ]: 0.5,
        [ EFFECT.SHADOWLAND ]: 0.5,
        [ EFFECT.THE_WAY_OF_THE_SPIDER ]: 0.5,
        [ EFFECT.A_BEING_DARKER_THAN_I ]: 0.5,
        [ EFFECT.FROM_LIGHT_TO_DARK ]: 0.5,
        [ EFFECT.HEALING_TOUCH ]: 0.5,
        [ EFFECT.TIME_WE_CHANGED_TOO ]: 0.5,
        [ EFFECT.BATTLEREALMS_CHANGING ]: 0.5,
        [ EFFECT.KINGS ]: 0.5,
        [ EFFECT.ROYALS ]: 0.5,
        [ EFFECT.WARRIORS ]: 0.5,
        [ EFFECT.DIMENSIONAL_BUDDIES ]: 0.5,
        [ EFFECT.MANY_AS_ONE ]: 0.5,
        [ EFFECT.POOR_UNFORTUNATE_SOUL ]: 0.5,
        [ EFFECT.QUEENS_OF_SOULS ]: 0.5,
        [ EFFECT.UNCHAINED ]: 0.5,
        [ EFFECT.WHAT_IF ]: 0.5,
        [ EFFECT.COSMIC_CONTROL ]: 0.5,
        [ EFFECT.CUBE_WIELDERS ]: 0.5,
        [ EFFECT.IDENTITY_DISORDER ]: 0.5,
        [ EFFECT.SHIELD_BUDDIES ]: 0.5,
        [ EFFECT.SPACE_SURFERS ]: 0.5,
        [ EFFECT.FORTIFY_ENHANCEMENT ]: 0.5,
        [ EFFECT.SKIRMISH_ENHANCEMENT ]: 0.5,
        [ EFFECT.SUPPORT_ENHANCEMENT ]: 0.5,
        [ EFFECT.MY_BEAUTIFUL_METEOR ]: 0.5,
        [ EFFECT.MY_WORLD_OF_METAL ]: 0.5,
        [ EFFECT.DECIMATION_SW ]: 0.5,
        [ EFFECT.CHAOS_RISING ]: 0.5,
        [ EFFECT.TILL_INFINITY_DO_US_PART ]: 0.5,
        [ EFFECT.DEMONIC_PACT ]: 0.5,
        [ EFFECT.SUPER_STARS ]: 0.5,
        [ EFFECT.OUT_OF_THIS_WORLD ]: 0.5,
        [ EFFECT.STAY_POSITIVE ]: 0.5,
        [ EFFECT.KO_QUEENS ]: 0.5,
        [ EFFECT.NEXT_ROUND_ON_ME ]: 0.5,
        [ EFFECT.MASTERFUL_COMBAT ]: 0.5,
        [ EFFECT.ARM_WRESTLING_CLUB ]: 0.5,
        [ EFFECT.PAWN_SET_FREE ]: 0.5,
        [ EFFECT.INCREDIBLE_SUBSTITUTE ]: 0.5,
        [ EFFECT.I_REQUIRE_THY_SHIELD ]: 0.5,
        [ EFFECT.START_WITH_FRESH_DEADPOOL ]: 0.5,
        [ EFFECT.ACCURATELY_MEASURE_INGREDIENTS ]: 0.5,
        [ EFFECT.BLEND_IN_SYMBIOTE ]: 0.5,
        [ EFFECT.ADD_PLAIN_WHITE_FLOUR ]: 0.5,
        [ EFFECT.FRY_IN_SKILLET ]: 0.5,
        [ EFFECT.ADJUST_COOKING_TIMER ]: 0.5,
        [ EFFECT.ALLOW_TO_COOL ]: 0.5,
        [ EFFECT.MUNCH_STUNNING_FOOD ]: 0.5,
        [ EFFECT.NOT_THE_HERO ]: 0.5,
        [ EFFECT.BUT_THE_BEST_VILLAIN ]: 0.5,
        [ EFFECT.CRIME_BOSSES ]: 0.5,
        [ EFFECT.CONTEMPTUOUS_MALICE ]: 0.5,
        [ EFFECT.GIANT_MONSTROSITIES ]: 0.5,
        [ EFFECT.ANGEL_ATTACK ]: 0.5,
        [ EFFECT.FIELD_TRIP ]: 0.5,
        [ EFFECT.SPIDERGEDDON ]: 0.5,
        [ EFFECT.STRANGE_BEASTS_AND_BIZARRE_MACHINES ]: 0.5,
        [ EFFECT.SUIT_UP ]: 0.5,
        [ EFFECT.TECHNICIAN ]: 0.5,
        [ EFFECT.AI_ENTHUSIASTS ]: 0.5,
        [ EFFECT.COWORKERS ]: 0.5,
        [ EFFECT.SPIDERVERSE_VETERANS ]: 0.5,
        [ EFFECT.SYMBIOTE_PROBLEMS ]: 0.5,
        [ EFFECT.WE_ARE_MANY ]: 0.5,
        [ EFFECT.ADVANCED_INTELLIGENCE ]: 0.5,
        // [ EFFECT.NEW_WAVE ]: 0.5,
        [ EFFECT.RESISTANCE_IS_FUTILE ]: 0.5,
        [ EFFECT.TERMINATED ]: 0.5,
        [ EFFECT.FIRE_AND_DRAGONS ]: 0.5,
        [ EFFECT.JUST_A_PHASE ]: 0.5,
        [ EFFECT.SHADOWY_HISTORY ]: 0.5,
        [ EFFECT.THROUGH_THICK_AND_THIN ]: 0.5,
        [ EFFECT.VICIOUS_KITTY ]: 0.5,
        [ EFFECT.WORTH_A_SHOT ]: 0.5,
        [ EFFECT.SPIDERSENSES_TINGLING ]: 0.5,
        [ EFFECT.SPIDERVERSE_MENTORS ]: 0.5,
        [ EFFECT.CYBERNETICS_UPGRADE_BLITZ ]: 0.5,
    },
    'defensive': {
        [ EFFECT.ATTACK ]: 0.1,
        [ EFFECT.IDOL ]: 0.3,
        [ EFFECT.INSEPARABLE ]: 0.1,
        [ EFFECT.MUTANT_AGENDA ]: 0.1,
        [ EFFECT.COSMIC_SUPREMACY ]: 0.2,
        [ EFFECT.CRITICAL_RATE ]: 0.1,
        [ EFFECT.CRITICAL_DAMAGE ]: 0.1,
        [ EFFECT.BLEED ]: 0.1,
        [ EFFECT.COMBO ]: 0.1,
        [ EFFECT.STUN_SPECIAL ]: 0.5,
        [ EFFECT.POWER_GAIN ]: 0.3,
        [ EFFECT.POWER_STEAL ]: 0.3,
        [ EFFECT.ITS_COMPLICATED ]: 0.8,
        [ EFFECT.PERFECT_BLOCK ]: 0.8,
        [ EFFECT.ARMOR ]: 0.7,
        [ EFFECT.HEALTH ]: 0.5,
        [ EFFECT.HEALTH_STEAL ]: 0.5,
        [ EFFECT.HEROES_FOR_HIRE ]: 0.5,
        [ EFFECT.THUNDERBOLTS ]: 0.6,
        [ EFFECT.MASTERMINDS ]: 0.1,
        [ EFFECT.SHIELD_AGENTS ]: 0.6,
        [ EFFECT.SHIELD_CLEARANCE ]: 0.8,
        [ EFFECT.LEGAL_DEFENSE ]: 0.5,
        [ EFFECT.SHARED_GENETIC_MEMORY ]: 0.5,
        [ EFFECT.DEMON_HUNTER ]: 0.5,
        [ EFFECT.SPIRIT_OF_JUSTICE ]: 0.5,
        [ EFFECT.HEIGHTENED_SENSES ]: 0.5,
        [ EFFECT.COMPETITION ]: 0.5,
        [ EFFECT.BANE_OF_HELLS_KITCHEN ]: 0.5,
        [ EFFECT.DEFENDERS_DESTROYER ]: 0.5,
        [ EFFECT.SPLIT_PERSONALITY ]: 0.5,
        [ EFFECT.ELECTRIC_SUPERCHARGE ]: 0.5,
        [ EFFECT.SEETHING_HATRED ]: 0.5,
        [ EFFECT.PARTICLE_PHYSICS ]: 0.5,
        [ EFFECT.ENGINEERING ]: 0.5,
        [ EFFECT.BIOCHEMISTRY ]: 0.5,
        [ EFFECT.AVENGERS_TRYOUT ]: 0.5,
        [ EFFECT.CONTEST_NOOBS ]: 0.5,
        [ EFFECT.KNOWLEDGE_SHARE ]: 0.5,
        [ EFFECT.MASTERS_OF_THE_SWORD ]: 0.5,
        [ EFFECT.SOUL_SEEKER ]: 0.5,
        [ EFFECT.WARRIOR_QUEENS ]: 0.5,
        [ EFFECT.LOYAL_MINISTER ]: 0.5,
        [ EFFECT.CROSS_TRAINING ]: 0.5,
        [ EFFECT.BELIEVER ]: 0.5,
        [ EFFECT.TEAM_BUILDING_EXERCISE ]: 0.5,
        [ EFFECT.LULLABY ]: 0.5,
        [ EFFECT.OFF_LIMITS ]: 0.5,
        [ EFFECT.PUNY_GOD ]: 0.5,
        [ EFFECT.OVERCOMING_FEAR ]: 0.5,
        [ EFFECT.LIKE_OLD_DAYS ]: 0.5,
        [ EFFECT.NOT_AFRAID_OF_DEATH ]: 0.5,
        [ EFFECT.FRIEND_FROM_WORK ]: 0.5,
        [ EFFECT.ADVANCED_IDEA_MECHANICS ]: 0.5,
        [ EFFECT.CHAIR_LARCENY ]: 0.5,
        [ EFFECT.IMMORTAL_SOULS ]: 0.5,
        [ EFFECT.QUEEN_OF_HEL ]: 0.5,
        [ EFFECT.HELL_LORDS ]: 0.5,
        [ EFFECT.CUBICLE_MATES ]: 0.5,
        [ EFFECT.OTHER_HALF ]: 0.5,
        [ EFFECT.TERMINATION_CONTRACT ]: 0.5,
        [ EFFECT.PROFESSORS_IN_CRIME ]: 0.5,
        [ EFFECT.MOSTLY_AVERAGE_JOES ]: 0.5,
        [ EFFECT.THUNDER ]: 0.5,
        [ EFFECT.TEAM_DEADPOOL_AWESOME_FORCE ]: 0.5,
        [ EFFECT.BROKEN_MINDS ]: 0.5,
        [ EFFECT.ANNOYANCES_ASSEMBLE ]: 0.5,
        [ EFFECT.SIX_PACK ]: 0.5,
        [ EFFECT.XFORCE ]: 0.5,
        [ EFFECT.WEAPON_X_STRIKE_TEAM ]: 0.5,
        [ EFFECT.CODE_RED_REVELATIONS ]: 0.5,
        [ EFFECT.MERCS_FOR_MONEY ]: 0.5,
        [ EFFECT.BETTER_LUCK_NEXT_TIME ]: 0.5,
        [ EFFECT.COMPLICATED ]: 0.5,
        [ EFFECT.ESOTERIC_INSIGHT ]: 0.5,
        [ EFFECT.COVERT_INSIGHT ]: 0.5,
        [ EFFECT.FAMILIAR_INSIGHT ]: 0.5,
        [ EFFECT.AI_UPGRADE ]: 0.5,
        [ EFFECT.WAKANDAN_INSIGHT ]: 0.5,
        [ EFFECT.ENHANCED_SOLDIERS ]: 0.5,
        [ EFFECT.WAKANDA_LEADERSHIP ]: 0.5,
        [ EFFECT.FEARLESS ]: 0.5,
        [ EFFECT.MUTANT_PURSUIT ]: 0.5,
        [ EFFECT.SKILL_TRAINING ]: 0.5,
        [ EFFECT.SCIENCE_RESEARCH ]: 0.5,
        [ EFFECT.MYSTIC_OBSERVATION ]: 0.5,
        [ EFFECT.TECH_ADVANCEMENT ]: 0.5,
        [ EFFECT.CHRONAL_ANCHOR ]: 0.5,
        [ EFFECT.ENERGY_CONDUIT ]: 0.5,
        [ EFFECT.DEMONS ]: 0.5,
        [ EFFECT.PACT_WITH_A_DEMON ]: 0.5,
        [ EFFECT.INHUMAN_ROYAL_FAMILY ]: 0.5,
        [ EFFECT.INSPIRATION ]: 0.5,
        [ EFFECT.GET_IN_THE_POOL ]: 0.5,
        [ EFFECT.SPIRITUAL_STRENGTH ]: 0.5,
        [ EFFECT.PLAYING_WITH_FIRE ]: 0.5,
        [ EFFECT.TECH_BREAKTHROUGH ]: 0.5,
        [ EFFECT.MUTANT_EVOLUTION ]: 0.5,
        [ EFFECT.SKILL_TRAINING_CAIW ]: 0.5,
        [ EFFECT.SCIENCE_EXPERIMENT ]: 0.5,
        [ EFFECT.MYSTIC_CRAFT ]: 0.5,
        [ EFFECT.COSMIC_POWER ]: 0.5,
        [ EFFECT.ADVANCED_TECH ]: 0.5,
        [ EFFECT.HARD_TO_HIT ]: 0.5,
        [ EFFECT.DEADLY_STING ]: 0.5,
        [ EFFECT.UNTAMED_FORCE ]: 0.5,
        [ EFFECT.DECIMATION ]: 0.5,
        [ EFFECT.NO_MERCY ]: 0.5,
        [ EFFECT.FORMIDABLE_FOE ]: 0.5,
        [ EFFECT.MICROSCOPIC_OBSERVATION ]: 0.5,
        [ EFFECT.THE_UNTOUCHABLES ]: 0.5,
        [ EFFECT.UNMERCIFUL_PUNISHMENT ]: 0.5,
        [ EFFECT.ASGARDIAN_HUNT ]: 0.5,
        [ EFFECT.SPECIAL_ASSIST ]: 0.5,
        [ EFFECT.HUNT_THE_UNCANNY ]: 0.5,
        [ EFFECT.CHALLENGE_DEFENSES ]: 0.5,
        [ EFFECT.GRIPPED_BY_FEAR ]: 0.5,
        [ EFFECT.ENGULFED_BY_THE_VOID ]: 0.5,
        [ EFFECT.ENCHANTED_BLADES ]: 0.5,
        [ EFFECT.LOST_DAUGHTERS_OF_ASGARD ]: 0.5,
        [ EFFECT.WARRIORS_OF_ASGARD ]: 0.5,
        [ EFFECT.PIT_FIGHTERS ]: 0.5,
        [ EFFECT.GRANDMASTERS_CHAMPIONS ]: 0.5,
        [ EFFECT.ELEMENTAL_HIDE ]: 0.5,
        [ EFFECT.DARK_ILLUMINATI ]: 0.5,
        [ EFFECT.ETERNAL_ADVERSARIES ]: 0.5,
        [ EFFECT.HAIL_HYDRA ]: 0.5,
        [ EFFECT.DARK_EMPOWERMENT ]: 0.5,
        [ EFFECT.METAL_MAYHEM ]: 0.5,
        [ EFFECT.XASSASSINS ]: 0.5,
        [ EFFECT.SEEING_RED ]: 0.5,
        [ EFFECT.DEADLY_PRESENCE ]: 0.5,
        [ EFFECT.MEMORIES_OF_GENOSHA ]: 0.5,
        [ EFFECT.IMPENETRABLE_HIDE ]: 0.5,
        [ EFFECT.ITS_COMPLICATED_2 ]: 0.5,
        [ EFFECT.PHOENIX_FORCE ]: 0.5,
        [ EFFECT.TOUGH_BRAWLERS ]: 0.5,
        [ EFFECT.PERSISTENT_FORCE ]: 0.5,
        [ EFFECT.COMBO_FIGHTER ]: 0.5,
        [ EFFECT.DAVID_AND_GOLIATH ]: 0.5,
        [ EFFECT.COMBO_BREAKERS ]: 0.5,
        [ EFFECT.WARRIORS_OF_THE_STARS ]: 0.5,
        [ EFFECT.FRIENDS ]: 0.5,
        [ EFFECT.SCHOOL_OF_HARD_ROCKS ]: 0.5,
        [ EFFECT.WORTHY_OPPONENT ]: 0.5,
        [ EFFECT.UNENDING_AMBITION ]: 0.5,
        [ EFFECT.MADCAP_EXPERIMENTALISTS ]: 0.5,
        [ EFFECT.TWISTED_ARCANISTS ]: 0.5,
        [ EFFECT.LEGION_ACCURSED ]: 0.5,
        [ EFFECT.GENETIC_RECODE_BARRIER ]: 0.5,
        [ EFFECT.GENETIC_RECODE_SURVIVAL ]: 0.5,
        [ EFFECT.GENETIC_RECODE_REGENESIS ]: 0.5,
        [ EFFECT.GENETIC_RECODE_EVOLUTION ]: 0.5,
        [ EFFECT.GENETIC_RECODE_HIVE_MIND ]: 0.5,
        [ EFFECT.GENETIC_RECODE_AGGRESSION ]: 0.5,
        [ EFFECT.GENETIC_RECODE_PROBABILITY ]: 0.5,
        [ EFFECT.GENETIC_RECODE_BLOODLETTING ]: 0.5,
        [ EFFECT.MYSTIC_MASTERS ]: 0.5,
        [ EFFECT.ANCIENT_HUNGER ]: 0.5,
        [ EFFECT.SUPREME_SYMBIOSIS ]: 0.5,
        [ EFFECT.MIDNIGHT_PURSUIT ]: 0.5,
        [ EFFECT.JUSTICE_ON_WHEELS ]: 0.5,
        [ EFFECT.CONTEST_TEAMMATES ]: 0.5,
        [ EFFECT.TACTICAL_TRAINING ]: 0.5,
        [ EFFECT.NIGHT_HAWKS ]: 0.5,
        [ EFFECT.DARK_JUSTICE ]: 0.5,
        [ EFFECT.BIRDS_OF_PREY ]: 0.5,
        [ EFFECT.RUNS_IN_THE_FAMILY ]: 0.5,
        [ EFFECT.OLD_TEAMMATES ]: 0.5,
        [ EFFECT.UNCANNY_AVENGERS ]: 0.5,
        [ EFFECT.GENETIC_MASTERPIECE ]: 0.5,
        [ EFFECT.MUTANT_DOMINION ]: 0.5,
        [ EFFECT.BLOOD_LINES ]: 0.5,
        [ EFFECT.MASTERMINDS_TWO ]: 0.5,
        [ EFFECT.STOLEN_MEMORIES ]: 0.5,
        [ EFFECT.PARTNERS_IN_SHIELD ]: 0.5,
        [ EFFECT.MARVELOUS ]: 0.5,
        [ EFFECT.FAN_CLUB ]: 0.5,
        [ EFFECT.RESTORATION_KIT ]: 0.5,
        [ EFFECT.STRATEGIC_SABOTAGE ]: 0.5,
        [ EFFECT.INCREASED_FIREPOWER ]: 0.5,
        [ EFFECT.CONTINGENCY_PLAN ]: 0.5,
        [ EFFECT.EXTREME_CONDITIONS_KIT ]: 0.5,
        [ EFFECT.POWER_KIT ]: 0.5,
        [ EFFECT.GWENOM_RISING ]: 0.5,
        [ EFFECT.AGENTS_OF_SMASH ]: 0.5,
        [ EFFECT.HUNTRESS_OF_THE_CONTEST ]: 0.5,
        [ EFFECT.SIBLING_RIVALRY ]: 0.5,
        [ EFFECT.CYBERNETICS_UPGRADE_ASSAULT ]: 0.5,
        [ EFFECT.CYBERNETICS_UPGRADE_TACTICS ]: 0.5,
        [ EFFECT.DOUBLE_NEGATIVE ]: 0.5,
        [ EFFECT.CHALLENGER ]: 0.5,
        [ EFFECT.RAIN_OF_FIRE ]: 0.5,
        [ EFFECT.TURN_UP_THE_HEAT ]: 0.5,
        [ EFFECT.A_SONG_OF_FIRE_AND_ICE ]: 0.5,
        [ EFFECT.FAMILIAR_FACES ]: 0.5,
        [ EFFECT.LAST_HOPE ]: 0.5,
        [ EFFECT.UNLIKELY_COMBINATION ]: 0.5,
        [ EFFECT.LIVE_AND_DIE_BY_THE_SWORD ]: 0.5,
        [ EFFECT.MASTERLESS ]: 0.5,
        [ EFFECT.LIEUTENANTS_OF_THE_BLACK_ORDER ]: 0.5,
        [ EFFECT.CULL_OF_THE_MAW ]: 0.5,
        [ EFFECT.INVASIVE_FORCE ]: 0.5,
        [ EFFECT.DISPLAY_OF_STRENGTH ]: 0.5,
        [ EFFECT.HEROES_NEVER_LEARN ]: 0.5,
        [ EFFECT.TIDE_TO_GO ]: 0.5,
        [ EFFECT.KINGS_OF_THE_WORLD ]: 0.5,
        [ EFFECT.BEACH_BODS ]: 0.5,
        [ EFFECT.FORCE_BLOCK ]: 0.5,
        [ EFFECT.TILL_DEATH ]: 0.5,
        [ EFFECT.UNPHASED ]: 0.5,
        [ EFFECT.ONE_WAY_OR_ANOTHER ]: 0.5,
        [ EFFECT.STARK_INTERNSHIP ]: 0.5,
        [ EFFECT.SPIDERMEN_IN_BLACK ]: 0.5,
        [ EFFECT.BAD_FOR_BUSINESS ]: 0.5,
        [ EFFECT.CULTURE_SHOCK ]: 0.5,
        [ EFFECT.MINE_CAN_HOVER ]: 0.5,
        [ EFFECT.ENCROACHING_INSANITY ]: 0.5,
        [ EFFECT.ENHANCED_ILLUSIONIST ]: 0.5,
        [ EFFECT.MENTAL_IMMUNITY ]: 0.5,
        [ EFFECT.NEW_MUTANTS ]: 0.5,
        [ EFFECT.AIM_TECHNOLOGY ]: 0.5,
        [ EFFECT.LEADING_AVENGERS ]: 0.5,
        [ EFFECT.SELFFRIENDS ]: 0.5,
        [ EFFECT.ROBOT_UPRISING ]: 0.5,
        [ EFFECT.GOING_VIRAL ]: 0.5,
        [ EFFECT.FIRST_OF_HIS_NAME ]: 0.5,
        [ EFFECT.DRY_ICE ]: 0.5,
        [ EFFECT.SENIORS_DISCOUNT ]: 0.5,
        [ EFFECT.JUDGEMENT_DAY ]: 0.5,
        [ EFFECT.A_SPELL_A_DAY_KEEPS_THE_DOCTOR_AWAY ]: 0.5,
        [ EFFECT.FIRE_AND_FORGET ]: 0.5,
        [ EFFECT.SPIDERS_BITE ]: 0.5,
        [ EFFECT.FEARSOME_FOUR ]: 0.5,
        [ EFFECT.BANE_OF_EVIL ]: 0.5,
        [ EFFECT.THINGS ]: 0.5,
        [ EFFECT.MISUNDERSTOOD_MONSTERS ]: 0.5,
        [ EFFECT.AI_UPRISING ]: 0.5,
        [ EFFECT.OUR_SHARED_CURSE ]: 0.5,
        [ EFFECT.HUNTING_PARTY ]: 0.5,
        [ EFFECT.BEAUTY_AND_THE_BEAST ]: 0.5,
        [ EFFECT.FANTASTIC_RAGE ]: 0.5,
        [ EFFECT.ENHANCED_FORCEFIELD ]: 0.5,
        [ EFFECT.GENIUS_INGENUITY ]: 0.5,
        [ EFFECT.SORCERY_REVERSAL ]: 0.5,
        [ EFFECT.COSMIC_OVERLOAD ]: 0.5,
        [ EFFECT.MYSTIC_TYRANTS ]: 0.5,
        [ EFFECT.HERBIE ]: 0.5,
        [ EFFECT.FANTASTIC_FOUR ]: 0.5,
        [ EFFECT.DO_US_PART ]: 0.5,
        [ EFFECT.COLLEGE_RIVALS ]: 0.5,
        [ EFFECT.SK_ASTRONOMY ]: 0.5,
        [ EFFECT.SK_ROBOTICS ]: 0.5,
        [ EFFECT.SK_GENETICS ]: 0.5,
        [ EFFECT.HERALDS_OF_GALACTUS ]: 0.5,
        [ EFFECT.SECRET_DEFENDERS ]: 0.5,
        [ EFFECT.MINE_TRAVELS_THROUGH_SPACE ]: 0.5,
        [ EFFECT.NEW_WARRIOR_BLOOD ]: 0.5,
        [ EFFECT.TOTAL_ANNIHILATION ]: 0.5,
        [ EFFECT.MAXIMUM_OUTPUT ]: 0.5,
        [ EFFECT.PHALANX_FEUD ]: 0.5,
        [ EFFECT.FULL_SPEED_AHEAD ]: 0.5,
        [ EFFECT.SUPERNANNY ]: 0.5,
        [ EFFECT.DEADPOOLS_GUIDE_TO_SUPER_VILLAINS ]: 0.5,
        [ EFFECT.HARDWIRED_FOR_HEARTBREAK ]: 0.5,
        [ EFFECT.BEAT_UP_THE_UNIVERSE ]: 0.5,
        [ EFFECT.MOJOVERSE ]: 0.5,
        [ EFFECT.SMILE_FOR_THE_CAMERAS ]: 0.5,
        [ EFFECT.WITHOUT_A_LEG_TO_STAND_ON ]: 0.5,
        [ EFFECT.CROWD_PLEASERS ]: 0.5,
        [ EFFECT.CIVIL_WAR_STORIES ]: 0.5,
        [ EFFECT.LOVE_TRIANGLES ]: 0.5,
        [ EFFECT.PROBABLY_OP ]: 0.5,
        [ EFFECT.GOOD_VIBRATIONS ]: 0.5,
        [ EFFECT.MONSTER_MASH ]: 0.5,
        [ EFFECT.FANTASTIC_FIENDS ]: 0.5,
        [ EFFECT.DEATH_AND_RESURRECTION ]: 0.5,
        [ EFFECT.ELDERS_GAME ]: 0.5,
        [ EFFECT.PRISONER ]: 0.5,
        [ EFFECT.A_GANG_OF ]: 0.5,
        [ EFFECT.LAB_PARTNERS ]: 0.5,
        [ EFFECT.TROPHY_CASE ]: 0.5,
        [ EFFECT.CHAMPIONS_OF_BATTLEWORLD ]: 0.5,
        [ EFFECT.DOCTORS_STRANGE ]: 0.5,
        [ EFFECT.MYSTIC_ARTS ]: 0.5,
        [ EFFECT.BLUETIFUL_PEOPLE ]: 0.5,
        [ EFFECT.GAMMA_HORDE ]: 0.5,
        [ EFFECT.HOUSE_OF_IRON ]: 0.5,
        [ EFFECT.SETUP_AND_SPIKE ]: 0.5,
        [ EFFECT.UNDER_THE_WEATHER ]: 0.5,
        [ EFFECT.KINGDOM_OF_WAKANDA ]: 0.5,
        [ EFFECT.SPIDERGUILD ]: 0.5,
        [ EFFECT.FAMILY_REUNION ]: 0.5,
        [ EFFECT.EASTERN_BLOCKERS ]: 0.5,
        [ EFFECT.LIVING_STEEL_CURTAIN ]: 0.5,
        [ EFFECT.MAGNIFICENT_MANES ]: 0.5,
        [ EFFECT.ENHANCED_WITH_CARBONADIUM ]: 0.5,
        [ EFFECT.REMEMBER_ME ]: 0.5,
        [ EFFECT.REMEMBERING_BUDAPEST ]: 0.5,
        [ EFFECT.COVERT_EXPERTISE ]: 0.5,
        [ EFFECT.WEST_COAST_AVENGERS ]: 0.5,
        [ EFFECT.FELINE_POSSESSION ]: 0.5,
        [ EFFECT.ENTREE ]: 0.5,
        [ EFFECT.BIG_GAME_HUNTERS ]: 0.5,
        [ EFFECT.NOT_THE_FACE ]: 0.5,
        [ EFFECT.SPIDER_MONKEY ]: 0.5,
        [ EFFECT.FURRY_FRENEMIES ]: 0.5,
        [ EFFECT.NO_EVIL ]: 0.5,
        [ EFFECT.ON_GUARD_FOR_THEE ]: 0.5,
        [ EFFECT.ALPHA_FLIGHT ]: 0.5,
        [ EFFECT.EXCAVATORS ]: 0.5,
        [ EFFECT.JUST_HAIR_AND_THINGS ]: 0.5,
        [ EFFECT.GAMMA_RAY_RAY ]: 0.5,
        [ EFFECT.FURRY_BUDS ]: 0.5,
        [ EFFECT.GIANT_CHALLENGERS ]: 0.5,
        [ EFFECT.COMMON_HISTORY ]: 0.5,
        [ EFFECT.NOVA_CORPS_VETERANS ]: 0.5,
        [ EFFECT.THE_HIGH_GROUND ]: 0.5,
        [ EFFECT.THE_FIRST_ONE ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_I ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_II ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_III ]: 0.5,
        [ EFFECT.BRINGER_OF_DEATH_IV ]: 0.5,
        [ EFFECT.GUARDIAN_OF_THE_PYRAMID ]: 0.5,
        [ EFFECT.IMPENDING_STORM ]: 0.5,
        [ EFFECT.YOUR_FATE_IS_MINE ]: 0.5,
        [ EFFECT.CHAOTIC_ENERGY ]: 0.5,
        [ EFFECT.CROSSOVER ]: 0.5,
        [ EFFECT.DEATHWISH ]: 0.5,
        [ EFFECT.GOODFELLA ]: 0.5,
        [ EFFECT.MERC_WITH_A_MOUTH ]: 0.5,
        [ EFFECT.STUCK_IN_LIMBO ]: 0.5,
        [ EFFECT.DRUG_I ]: 0.5,
        [ EFFECT.DRUG_L ]: 0.5,
        [ EFFECT.DRUG_M ]: 0.5,
        [ EFFECT.GATEWAY ]: 0.5,
        [ EFFECT.HABITAT ]: 0.5,
        [ EFFECT.FIRST_CRUSH ]: 0.5,
        [ EFFECT.FULL_METAL ]: 0.5,
        [ EFFECT.NOT_SO_HIDDEN_DRAGON ]: 0.5,
        [ EFFECT.STUDENT_LOANS ]: 0.5,
        [ EFFECT.MY_BROTHERHOOD ]: 0.5,
        [ EFFECT.MY_CONTEST_NOW ]: 0.5,
        [ EFFECT.MY_HELLFIRE_CLUB ]: 0.5,
        [ EFFECT.MY_METALLIC_ANTIPATHY ]: 0.5,
        [ EFFECT.METALLIC_AFFINITY ]: 0.5,
        [ EFFECT.REDEMPTION ]: 0.5,
        [ EFFECT.RISE_AGAINST_THE_CONTEST ]: 0.5,
        [ EFFECT.FAMILY_FEUD ]: 0.5,
        [ EFFECT.HATRED ]: 0.5,
        [ EFFECT.OSBORN_TO_BE_WILD ]: 0.5,
        [ EFFECT.SELF_CENTERED ]: 0.5,
        [ EFFECT.SYMBIOTE_CONSCIOUSNESS ]: 0.5,
        [ EFFECT.COSMIC_BANE_OF_EVIL ]: 0.5,
        [ EFFECT.COSMIC_JUSTICE_ON_WHEELS ]: 0.5,
        [ EFFECT.PUNISHMENTS_OF_INFINITE_VARIETY ]: 0.5,
        [ EFFECT.SPIRITS_OF_VENGEANCE ]: 0.5,
        [ EFFECT.FASTBALL_SPECIAL ]: 0.5,
        [ EFFECT.FEEL_CYTORAKS_EMBRACE ]: 0.5,
        [ EFFECT.DONT_MENTION_PUNY_BANNER ]: 0.5,
        [ EFFECT.TECHNOLOGICAL_COMPETITION ]: 0.5,
        [ EFFECT.ENGINEERING_EXPERTS ]: 0.5,
        [ EFFECT.IT_AINT_EASY ]: 0.5,
        [ EFFECT.SINGULARITY ]: 0.5,
        [ EFFECT.ENHANCED_ADAMANTIUM ]: 0.5,
        [ EFFECT.NO_NOT_YOU ]: 0.5,
        [ EFFECT.THE_BRAVE_AND_THE_BOULDER ]: 0.5,
        [ EFFECT.PASSIVE_AGGRESSIVE ]: 0.5,
        [ EFFECT.ARACHNID_HUNTERS ]: 0.5,
        [ EFFECT.ALPHA_FLIGHT_SPACE_STATION ]: 0.5,
        [ EFFECT.GAMMA_MUTATES ]: 0.5,
        [ EFFECT.EXTREME_MEASURES ]: 0.5,
        [ EFFECT.HELL_AND_BACK ]: 0.5,
        [ EFFECT.FAIREST_OF_THEM_ALL ]: 0.5,
        [ EFFECT.ABOMINABLE_COMRADE ]: 0.5,
        [ EFFECT.IMMORTAL_RULERS ]: 0.5,
        [ EFFECT.IMMORTAL_KINGS ]: 0.5,
        [ EFFECT.TWO_DAYS_THIRTY_YEARS ]: 0.5,
        [ EFFECT.SATURDAY_MORNING_CARTOONS ]: 0.5,
        [ EFFECT.SWINESTER_SIX_MOST_WANTED ]: 0.5,
        [ EFFECT.FOURTH_WALL_CRAWLER ]: 0.5,
        [ EFFECT.FISK_DOWNFALL ]: 0.5,
        [ EFFECT.SECRET_OF_THE_HAND ]: 0.5,
        [ EFFECT.RULE_OF_LAW ]: 0.5,
        [ EFFECT.STRENGTH_OF_MARTYRS ]: 0.5,
        [ EFFECT.ALL_ADAMANTIUM_AND_ATTITUDE ]: 0.5,
        [ EFFECT.DEAL_WITH_IT ]: 0.5,
        [ EFFECT.EXECUTE_TARGET_ACQUISITION_SUBROUTINE ]: 0.5,
        [ EFFECT.PETITE ]: 0.5,
        [ EFFECT.THE_LUCKY_ONE ]: 0.5,
        [ EFFECT.YOURE_TANGLING_WITH_THE_WRONG_XMEN ]: 0.5,
        [ EFFECT.BIG_BAD_DAD ]: 0.5,
        [ EFFECT.BULL_TARGETS ]: 0.5,
        [ EFFECT.CLONED_AT_BIRTH ]: 0.5,
        [ EFFECT.MISS_ME ]: 0.5,
        [ EFFECT.HOSTILE_TAKEOVER ]: 0.5,
        [ EFFECT.WEDDING_CRASHER ]: 0.5,
        [ EFFECT.DINKY_SHRINKS ]: 0.5,
        [ EFFECT.MALICE ]: 0.5,
        [ EFFECT.PURE_HATRED ]: 0.5,
        [ EFFECT.THERE_GOES_THE_MULTIVERSE ]: 0.5,
        [ EFFECT.POWER_OF_MONEY ]: 0.5,
        [ EFFECT.REVOLUTIONS_NEED_ARMS ]: 0.5,
        [ EFFECT.AMBER_PRISON ]: 0.5,
        [ EFFECT.BANISHED ]: 0.5,
        [ EFFECT.ENERGY_ABSORPTION ]: 0.5,
        [ EFFECT.FUELED_WITH_RAGE ]: 0.5,
        [ EFFECT.RAGE_ON ]: 0.5,
        [ EFFECT.BATTLE_OF_REALMS ]: 0.5,
        [ EFFECT.OATHSWORN ]: 0.5,
        [ EFFECT.ODINSONS_AND_ODINSDOTTIRS ]: 0.5,
        [ EFFECT.WARMONGER ]: 0.5,
        [ EFFECT.HYDRA_RECRUITERS ]: 0.5,
        [ EFFECT.MERCENARY_COMPETITION ]: 0.5,
        [ EFFECT.CONTEMPTUOUS_HATRED ]: 0.5,
        [ EFFECT.WE_AINT_NO_PUNCHLINE ]: 0.5,
        [ EFFECT.NEW_YORK_BRAWLERS ]: 0.5,
        [ EFFECT.NOT_SO_UNCANNY ]: 0.5,
        [ EFFECT.IRON_MEN ]: 0.5,
        [ EFFECT.ASGARDIAN_REPUBLIC ]: 0.5,
        [ EFFECT.PATRIOT_GARRISON ]: 0.5,
        [ EFFECT.PET_PALS ]: 0.5,
        [ EFFECT.HUNTRESSES ]: 0.5,
        [ EFFECT.PYRAMID_X ]: 0.5,
        [ EFFECT.TEMPLE_OF_VISHANTI ]: 0.5,
        [ EFFECT.TRIBAL_WARFARE ]: 0.5,
        [ EFFECT.EYES_OF_THE_DRAGON ]: 0.5,
        [ EFFECT.MASTER_MARTIAL_ARTISTS ]: 0.5,
        [ EFFECT.SHADOWLAND ]: 0.5,
        [ EFFECT.THE_WAY_OF_THE_SPIDER ]: 0.5,
        [ EFFECT.A_BEING_DARKER_THAN_I ]: 0.5,
        [ EFFECT.FROM_LIGHT_TO_DARK ]: 0.5,
        [ EFFECT.HEALING_TOUCH ]: 0.5,
        [ EFFECT.TIME_WE_CHANGED_TOO ]: 0.5,
        [ EFFECT.BATTLEREALMS_CHANGING ]: 0.5,
        [ EFFECT.KINGS ]: 0.5,
        [ EFFECT.ROYALS ]: 0.5,
        [ EFFECT.WARRIORS ]: 0.5,
        [ EFFECT.DIMENSIONAL_BUDDIES ]: 0.5,
        [ EFFECT.MANY_AS_ONE ]: 0.5,
        [ EFFECT.POOR_UNFORTUNATE_SOUL ]: 0.5,
        [ EFFECT.QUEENS_OF_SOULS ]: 0.5,
        [ EFFECT.UNCHAINED ]: 0.5,
        [ EFFECT.WHAT_IF ]: 0.5,
        [ EFFECT.COSMIC_CONTROL ]: 0.5,
        [ EFFECT.CUBE_WIELDERS ]: 0.5,
        [ EFFECT.IDENTITY_DISORDER ]: 0.5,
        [ EFFECT.SHIELD_BUDDIES ]: 0.5,
        [ EFFECT.SPACE_SURFERS ]: 0.5,
        [ EFFECT.FORTIFY_ENHANCEMENT ]: 0.5,
        [ EFFECT.SKIRMISH_ENHANCEMENT ]: 0.5,
        [ EFFECT.SUPPORT_ENHANCEMENT ]: 0.5,
        [ EFFECT.MY_BEAUTIFUL_METEOR ]: 0.5,
        [ EFFECT.MY_WORLD_OF_METAL ]: 0.5,
        [ EFFECT.DECIMATION_SW ]: 0.5,
        [ EFFECT.CHAOS_RISING ]: 0.5,
        [ EFFECT.TILL_INFINITY_DO_US_PART ]: 0.5,
        [ EFFECT.DEMONIC_PACT ]: 0.5,
        [ EFFECT.SUPER_STARS ]: 0.5,
        [ EFFECT.OUT_OF_THIS_WORLD ]: 0.5,
        [ EFFECT.STAY_POSITIVE ]: 0.5,
        [ EFFECT.KO_QUEENS ]: 0.5,
        [ EFFECT.NEXT_ROUND_ON_ME ]: 0.5,
        [ EFFECT.MASTERFUL_COMBAT ]: 0.5,
        [ EFFECT.ARM_WRESTLING_CLUB ]: 0.5,
        [ EFFECT.PAWN_SET_FREE ]: 0.5,
        [ EFFECT.INCREDIBLE_SUBSTITUTE ]: 0.5,
        [ EFFECT.I_REQUIRE_THY_SHIELD ]: 0.5,
        [ EFFECT.START_WITH_FRESH_DEADPOOL ]: 0.5,
        [ EFFECT.ACCURATELY_MEASURE_INGREDIENTS ]: 0.5,
        [ EFFECT.BLEND_IN_SYMBIOTE ]: 0.5,
        [ EFFECT.ADD_PLAIN_WHITE_FLOUR ]: 0.5,
        [ EFFECT.FRY_IN_SKILLET ]: 0.5,
        [ EFFECT.ADJUST_COOKING_TIMER ]: 0.5,
        [ EFFECT.ALLOW_TO_COOL ]: 0.5,
        [ EFFECT.MUNCH_STUNNING_FOOD ]: 0.5,
        [ EFFECT.NOT_THE_HERO ]: 0.5,
        [ EFFECT.BUT_THE_BEST_VILLAIN ]: 0.5,
        [ EFFECT.CRIME_BOSSES ]: 0.5,
        [ EFFECT.CONTEMPTUOUS_MALICE ]: 0.5,
        [ EFFECT.GIANT_MONSTROSITIES ]: 0.5,
        [ EFFECT.ANGEL_ATTACK ]: 0.5,
        [ EFFECT.FIELD_TRIP ]: 0.5,
        [ EFFECT.SPIDERGEDDON ]: 0.5,
        [ EFFECT.STRANGE_BEASTS_AND_BIZARRE_MACHINES ]: 0.5,
        [ EFFECT.SUIT_UP ]: 0.5,
        [ EFFECT.TECHNICIAN ]: 0.5,
        [ EFFECT.AI_ENTHUSIASTS ]: 0.5,
        [ EFFECT.COWORKERS ]: 0.5,
        [ EFFECT.SPIDERVERSE_VETERANS ]: 0.5,
        [ EFFECT.SYMBIOTE_PROBLEMS ]: 0.5,
        [ EFFECT.WE_ARE_MANY ]: 0.5,
        [ EFFECT.ADVANCED_INTELLIGENCE ]: 0.5,
        // [ EFFECT.NEW_WAVE ]: 0.5,
        [ EFFECT.RESISTANCE_IS_FUTILE ]: 0.5,
        [ EFFECT.TERMINATED ]: 0.5,
        [ EFFECT.FIRE_AND_DRAGONS ]: 0.5,
        [ EFFECT.JUST_A_PHASE ]: 0.5,
        [ EFFECT.SHADOWY_HISTORY ]: 0.5,
        [ EFFECT.THROUGH_THICK_AND_THIN ]: 0.5,
        [ EFFECT.VICIOUS_KITTY ]: 0.5,
        [ EFFECT.WORTH_A_SHOT ]: 0.5,
        [ EFFECT.SPIDERSENSES_TINGLING ]: 0.5,
        [ EFFECT.SPIDERVERSE_MENTORS ]: 0.5,
        [ EFFECT.CYBERNETICS_UPGRADE_BLITZ ]: 0.5,
    },
};

const PRESETS_DUPLICATES = {
    'all': {
        'duplicates-2': 1,
        'duplicates-3': 1,
        'duplicates-4': 1,
        'duplicates-5': 1,
    },
    'balanced': {
        'duplicates-2': 0.8,
        'duplicates-3': 0.4,
        'duplicates-4': 0.2,
        'duplicates-5': 0.1,
    },
    'none': {
        'duplicates-2': 0,
        'duplicates-3': 0,
        'duplicates-4': 0,
        'duplicates-5': 0,
    },
};

const PRESETS_RANGE = {
    'all': {
        'minimum-champion': 0,
        'maximum-champion': 10000,
        'minimum-team': 0,
        'maximum-team': 50000,
    },
    'streak': {
        'minimum-team': 4000,
        'maximum-team': 4500,
    },
};

const DEFAULT_WILLPOWER_SAFE = false;

const DEFAULT_BASE = 0;

const DEFAULT_SANDBAGGING = false;

const DEFAULT_RANGE = {
    ...PRESETS_RANGE[ 'all' ],
};

const DEFAULT_WEIGHTS = {
    ...PRESETS_DUPLICATES[ 'balanced' ],
    ...PRESETS[ 'offensive' ],
    'base': DEFAULT_BASE,
};

const teams = {
    type: ROLE.ARENA,
    size: 3,
    stars: {
        1: true,
        2: true,
        3: true,
        4: true,
        5: true,
    },
    types:{
        [ TYPE.COSMIC ]: true,
        [ TYPE.TECH ]: true,
        [ TYPE.MUTANT ]: true,
        [ TYPE.SKILL ]: true,
        [ TYPE.SCIENCE ]: true,
        [ TYPE.MYSTIC ]: true,
    },
    weights: {
        ...DEFAULT_WEIGHTS,
    },
    range: {
        ...DEFAULT_RANGE,
    },
    willpowersafe: DEFAULT_WILLPOWER_SAFE,
    sandbagging: DEFAULT_SANDBAGGING,
    ...fromStorage('teams', {}),
    progress: 0,
    building: false,
    result: {},
};

// Apply missing defaults
Object.keys(DEFAULT_WEIGHTS).forEach((key) => {
    if(!(key in teams.weights)) {
        teams.weights[ key ] = DEFAULT_WEIGHTS[ key ];
    }
});
Object.keys(DEFAULT_RANGE).forEach((key) => {
    if(!(key in teams.range)) {
        teams.range[ key ] = DEFAULT_RANGE[ key ];
    }
});

//assign missing fields a default value.
for(const key in DEFAULT_WEIGHTS) {
    if(teams.weights[ key ] === undefined) {
        teams.weights[ key ] = DEFAULT_WEIGHTS[ key ];
    }
}

function save() {
    toStorage('teams', {
        type: teams.type,
        size: teams.size,
        stars: teams.stars,
        types: teams.types,
        weights: teams.weights,
        range: teams.range,
        sandbagging: teams.sandbagging,
        willpowersafe: teams.willpowersafe,
    });
}

function loadTeam(type, size) {
    if(type === ROLE.ARENA) {
        return;
    }
    const champions = roster.filter((champion) => champion && champion.attr.role === type);
    if(champions.length === size) {
        champions.sort();
        const synergies = synergiesFromChampions(champions);
        teams.result[ `${ type }-${ size }` ] = {
            teams: [
                {
                    champions,
                    synergies,
                },
            ],
            counts: {
                teams: 1,
                synergies: synergies.length,
            },
            extras: [],
        };
    }
    else {
        teams.result[ `${ type }-${ size }` ] = null;
    }
}

[
    { type: ROLE.ALLIANCE_QUEST, size: 3 },
    { type: ROLE.ALLIANCE_WAR_ATTACK, size: 3 },
    { type: ROLE.ALLIANCE_WAR_DEFENSE, size: 5 },
].forEach(({ type, size }) => loadTeam(type, size));

function saveTeam() {
    teams.last = Date.now();
    if(teams.type === ROLE.ARENA || teams.type === ROLE.QUEST) {
        return;
    }
    const result = teams.result[ `${ teams.type }-${ teams.size }` ];
    const champions = result && result.teams && result.teams[ 0 ] && result.teams[ 0 ].champions;
    roster.setTeam(teams.type, champions || []);
}

function idToRosterChampion(id) {
    const { uid, stars } = Champion.idToObject(id);
    return roster.filter(({ attr }) => attr.uid === uid && attr.stars === stars)[ 0 ];
}

let lockedTeams = [];
let lockedTeamMap = {};
let lockedChampionMap = {};
function lockTeams(map = {}) {
    lockedTeams = [];
    lockedTeamMap = {};
    lockedChampionMap = {};
    Object.keys(map)
        .filter((key) => map[ key ])
        .forEach((tid) => {
            const champions = map[ tid ];
            const uids = tid.split('_');
            lockedTeams.push(champions);
            lockedTeamMap[ tid ] = champions;
            uids.forEach((id) => {
                lockedChampionMap[ id ] = true;
            });
        });
}
function isTeamLocked(tid) {
    return Boolean(lockedTeamMap[ tid ]);
}
function isChampionLocked(uid) {
    return lockedChampionMap[ uid ];
}

let progressResetTimeout;

let worker = new Worker();
let lastWorker;

function buildTeam() {
    clearTimeout(progressResetTimeout);
    new Promise((resolve) => {
        if(lastWorker)
            lastWorker.terminate();
        lastWorker = worker;
        worker.onmessage = (event) => {
            switch(event.data.type) {
                case 'result': {
                    teams.progress = 1;
                    setTimeout(() => resolve(event.data.data), 50);
                    requestRedraw();
                    break;
                }
                case 'progress': {
                    const progress = event.data.data;
                    teams.progress = progress.current / progress.max;
                    requestRedraw(teams.progress > 0 && teams.progress < 1? 5: 0);
                    break;
                }
            }
        };
        worker.postMessage({
            type: 'build',
            data: {
                type: teams.type,
                champions: roster
                    .filter(({ attr }) => teams.types[ attr.typeId ] !== false)
                    .filter(({ attr }) => teams.stars[ attr.stars ] !== false)
                    .filter((champion) => {
                        const pi = champion.attr.pi || champion.pi;
                        return teams.range[ 'minimum-champion' ] <= pi && teams.range[ 'maximum-champion' ] >= pi;
                    })
                    .filter(
                        teams.type !== ROLE.ARENA?
                            ({ attr }) => !attr.role || attr.role === ROLE.ARENA || attr.role === teams.type:
                            ({ id }) => !isChampionLocked(id)
                    )
                    .filter(({ attr }) => !teams.willpowersafe || WILLPOWER_SAFE_CHAMPIONS[ attr.uid ])
                    .map((champion) => champion.attr),
                size: teams.size,
                sandbagging: teams.sandbagging,
                weights: {
                    ...teams.weights,
                },
                range: {
                    ...teams.range,
                },
            },
        });
        teams.building = true;
        teams.progress = 0;
    })
        .then((result) => {
            let teamsCount = 0;
            let synergiesCount = 0;
            const teamsList = result.teams.map((team) => {
                team.sort();
                const champions = team.map(idToRosterChampion);
                const synergies = synergiesFromChampions(champions);
                teamsCount++;
                synergiesCount += synergies.length;
                return {
                    champions,
                    synergies,
                };
            });
            if(teams.type === ROLE.ARENA) {
                teamsList.unshift(...lockedTeams.map((champions) => {
                    const synergies = synergiesFromChampions(champions);
                    teamsCount++;
                    synergiesCount += synergies.length;
                    return {
                        champions,
                        synergies: synergiesFromChampions(champions),
                    };
                }));
            }
            teams.result[ `${ teams.type }-${ teams.size }` ] = {
                ...result,
                teams: teamsList,
                counts: {
                    teams: teamsCount,
                    synergies: synergiesCount,
                },
                extras: result.extras.map(idToRosterChampion),
            };
            saveTeam();
            teams.building = false;
            requestRedraw();
            return new Promise((resolve) => (progressResetTimeout = setTimeout(resolve, 250)));
        })
        .then(() => {
            teams.progress = 0;
            requestRedraw();
            notify({
                message: lang.string('notification-team-built'),
                tag: 'team-built',
                onclick: () => {
                    app.menuOpen = false;
                    router.setRoute('/teams');
                    requestRedraw();
                },
            });
        });
    worker = new Worker();
}

export { PRESETS, PRESETS_DUPLICATES, PRESETS_RANGE };
export { save, saveTeam, loadTeam, buildTeam, lockTeams, isTeamLocked, lockedTeamMap };
export default teams;



// WEBPACK FOOTER //
// ./src/service/teams.js